(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Super simple wysiwyg editor v0.8.2
 * http://summernote.org/
 *
 * summernote.js
 * Copyright 2013-2016 Alan Hong. and other contributors
 * summernote may be freely distributed under the MIT license./
 *
 * Date: 2016-08-08T01:21Z
 */
(function (factory) {
  /* global define */
  // Browser globals
  factory(window.jQuery);
}(function ($) {
  'use strict';

  /**
   * @class core.func
   *
   * func utils (for high-order func's arg)
   *
   * @singleton
   * @alternateClassName func
   */
  var func = (function () {
    var eq = function (itemA) {
      return function (itemB) {
        return itemA === itemB;
      };
    };

    var eq2 = function (itemA, itemB) {
      return itemA === itemB;
    };

    var peq2 = function (propName) {
      return function (itemA, itemB) {
        return itemA[propName] === itemB[propName];
      };
    };

    var ok = function () {
      return true;
    };

    var fail = function () {
      return false;
    };

    var not = function (f) {
      return function () {
        return !f.apply(f, arguments);
      };
    };

    var and = function (fA, fB) {
      return function (item) {
        return fA(item) && fB(item);
      };
    };

    var self = function (a) {
      return a;
    };

    var invoke = function (obj, method) {
      return function () {
        return obj[method].apply(obj, arguments);
      };
    };

    var idCounter = 0;

    /**
     * generate a globally-unique id
     *
     * @param {String} [prefix]
     */
    var uniqueId = function (prefix) {
      var id = ++idCounter + '';
      return prefix ? prefix + id : id;
    };

    /**
     * returns bnd (bounds) from rect
     *
     * - IE Compatibility Issue: http://goo.gl/sRLOAo
     * - Scroll Issue: http://goo.gl/sNjUc
     *
     * @param {Rect} rect
     * @return {Object} bounds
     * @return {Number} bounds.top
     * @return {Number} bounds.left
     * @return {Number} bounds.width
     * @return {Number} bounds.height
     */
    var rect2bnd = function (rect) {
      var $document = $(document);
      return {
        top: rect.top + $document.scrollTop(),
        left: rect.left + $document.scrollLeft(),
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    };

    /**
     * returns a copy of the object where the keys have become the values and the values the keys.
     * @param {Object} obj
     * @return {Object}
     */
    var invertObject = function (obj) {
      var inverted = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          inverted[obj[key]] = key;
        }
      }
      return inverted;
    };

    /**
     * @param {String} namespace
     * @param {String} [prefix]
     * @return {String}
     */
    var namespaceToCamel = function (namespace, prefix) {
      prefix = prefix || '';
      return prefix + namespace.split('.').map(function (name) {
        return name.substring(0, 1).toUpperCase() + name.substring(1);
      }).join('');
    };

    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     * @param {Function} func
     * @param {Number} wait
     * @param {Boolean} immediate
     * @return {Function}
     */
    var debounce = function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    };

    return {
      eq: eq,
      eq2: eq2,
      peq2: peq2,
      ok: ok,
      fail: fail,
      self: self,
      not: not,
      and: and,
      invoke: invoke,
      uniqueId: uniqueId,
      rect2bnd: rect2bnd,
      invertObject: invertObject,
      namespaceToCamel: namespaceToCamel,
      debounce: debounce
    };
  })();

  /**
   * @class core.list
   *
   * list utils
   *
   * @singleton
   * @alternateClassName list
   */
  var list = (function () {
    /**
     * returns the first item of an array.
     *
     * @param {Array} array
     */
    var head = function (array) {
      return array[0];
    };

    /**
     * returns the last item of an array.
     *
     * @param {Array} array
     */
    var last = function (array) {
      return array[array.length - 1];
    };

    /**
     * returns everything but the last entry of the array.
     *
     * @param {Array} array
     */
    var initial = function (array) {
      return array.slice(0, array.length - 1);
    };

    /**
     * returns the rest of the items in an array.
     *
     * @param {Array} array
     */
    var tail = function (array) {
      return array.slice(1);
    };

    /**
     * returns item of array
     */
    var find = function (array, pred) {
      for (var idx = 0, len = array.length; idx < len; idx ++) {
        var item = array[idx];
        if (pred(item)) {
          return item;
        }
      }
    };

    /**
     * returns true if all of the values in the array pass the predicate truth test.
     */
    var all = function (array, pred) {
      for (var idx = 0, len = array.length; idx < len; idx ++) {
        if (!pred(array[idx])) {
          return false;
        }
      }
      return true;
    };

    /**
     * returns index of item
     */
    var indexOf = function (array, item) {
      return $.inArray(item, array);
    };

    /**
     * returns true if the value is present in the list.
     */
    var contains = function (array, item) {
      return indexOf(array, item) !== -1;
    };

    /**
     * get sum from a list
     *
     * @param {Array} array - array
     * @param {Function} fn - iterator
     */
    var sum = function (array, fn) {
      fn = fn || func.self;
      return array.reduce(function (memo, v) {
        return memo + fn(v);
      }, 0);
    };

    /**
     * returns a copy of the collection with array type.
     * @param {Collection} collection - collection eg) node.childNodes, ...
     */
    var from = function (collection) {
      var result = [], idx = -1, length = collection.length;
      while (++idx < length) {
        result[idx] = collection[idx];
      }
      return result;
    };

    /**
     * returns whether list is empty or not
     */
    var isEmpty = function (array) {
      return !array || !array.length;
    };

    /**
     * cluster elements by predicate function.
     *
     * @param {Array} array - array
     * @param {Function} fn - predicate function for cluster rule
     * @param {Array[]}
     */
    var clusterBy = function (array, fn) {
      if (!array.length) { return []; }
      var aTail = tail(array);
      return aTail.reduce(function (memo, v) {
        var aLast = last(memo);
        if (fn(last(aLast), v)) {
          aLast[aLast.length] = v;
        } else {
          memo[memo.length] = [v];
        }
        return memo;
      }, [[head(array)]]);
    };

    /**
     * returns a copy of the array with all false values removed
     *
     * @param {Array} array - array
     * @param {Function} fn - predicate function for cluster rule
     */
    var compact = function (array) {
      var aResult = [];
      for (var idx = 0, len = array.length; idx < len; idx ++) {
        if (array[idx]) { aResult.push(array[idx]); }
      }
      return aResult;
    };

    /**
     * produces a duplicate-free version of the array
     *
     * @param {Array} array
     */
    var unique = function (array) {
      var results = [];

      for (var idx = 0, len = array.length; idx < len; idx ++) {
        if (!contains(results, array[idx])) {
          results.push(array[idx]);
        }
      }

      return results;
    };

    /**
     * returns next item.
     * @param {Array} array
     */
    var next = function (array, item) {
      var idx = indexOf(array, item);
      if (idx === -1) { return null; }

      return array[idx + 1];
    };

    /**
     * returns prev item.
     * @param {Array} array
     */
    var prev = function (array, item) {
      var idx = indexOf(array, item);
      if (idx === -1) { return null; }

      return array[idx - 1];
    };

    return { head: head, last: last, initial: initial, tail: tail,
             prev: prev, next: next, find: find, contains: contains,
             all: all, sum: sum, from: from, isEmpty: isEmpty,
             clusterBy: clusterBy, compact: compact, unique: unique };
  })();

  var isSupportAmd = typeof define === 'function' && define.amd;

  /**
   * returns whether font is installed or not.
   *
   * @param {String} fontName
   * @return {Boolean}
   */
  var isFontInstalled = function (fontName) {
    var testFontName = fontName === 'Comic Sans MS' ? 'Courier New' : 'Comic Sans MS';
    var $tester = $('<div>').css({
      position: 'absolute',
      left: '-9999px',
      top: '-9999px',
      fontSize: '200px'
    }).text('mmmmmmmmmwwwwwww').appendTo(document.body);

    var originalWidth = $tester.css('fontFamily', testFontName).width();
    var width = $tester.css('fontFamily', fontName + ',' + testFontName).width();

    $tester.remove();

    return originalWidth !== width;
  };

  var userAgent = navigator.userAgent;
  var isMSIE = /MSIE|Trident/i.test(userAgent);
  var browserVersion;
  if (isMSIE) {
    var matches = /MSIE (\d+[.]\d+)/.exec(userAgent);
    if (matches) {
      browserVersion = parseFloat(matches[1]);
    }
    matches = /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(userAgent);
    if (matches) {
      browserVersion = parseFloat(matches[1]);
    }
  }

  var isEdge = /Edge\/\d+/.test(userAgent);

  var hasCodeMirror = !!window.CodeMirror;
  if (!hasCodeMirror && isSupportAmd && typeof require !== 'undefined') {
    if (typeof require.resolve !== 'undefined') {
      try {
        // If CodeMirror can't be resolved, `require.resolve` will throw an
        // exception and `hasCodeMirror` won't be set to `true`.
        require.resolve('codemirror');
        hasCodeMirror = true;
      } catch (e) {
        // Do nothing.
      }
    } else if (typeof eval('require').specified !== 'undefined') {
      hasCodeMirror = eval('require').specified('codemirror');
    }
  }

  /**
   * @class core.agent
   *
   * Object which check platform and agent
   *
   * @singleton
   * @alternateClassName agent
   */
  var agent = {
    isMac: navigator.appVersion.indexOf('Mac') > -1,
    isMSIE: isMSIE,
    isEdge: isEdge,
    isFF: !isEdge && /firefox/i.test(userAgent),
    isPhantom: /PhantomJS/i.test(userAgent),
    isWebkit: !isEdge && /webkit/i.test(userAgent),
    isChrome: !isEdge && /chrome/i.test(userAgent),
    isSafari: !isEdge && /safari/i.test(userAgent),
    browserVersion: browserVersion,
    jqueryVersion: parseFloat($.fn.jquery),
    isSupportAmd: isSupportAmd,
    hasCodeMirror: hasCodeMirror,
    isFontInstalled: isFontInstalled,
    isW3CRangeSupport: !!document.createRange
  };


  var NBSP_CHAR = String.fromCharCode(160);
  var ZERO_WIDTH_NBSP_CHAR = '\ufeff';

  /**
   * @class core.dom
   *
   * Dom functions
   *
   * @singleton
   * @alternateClassName dom
   */
  var dom = (function () {
    /**
     * @method isEditable
     *
     * returns whether node is `note-editable` or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    var isEditable = function (node) {
      return node && $(node).hasClass('note-editable');
    };

    /**
     * @method isControlSizing
     *
     * returns whether node is `note-control-sizing` or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    var isControlSizing = function (node) {
      return node && $(node).hasClass('note-control-sizing');
    };

    /**
     * @method makePredByNodeName
     *
     * returns predicate which judge whether nodeName is same
     *
     * @param {String} nodeName
     * @return {Function}
     */
    var makePredByNodeName = function (nodeName) {
      nodeName = nodeName.toUpperCase();
      return function (node) {
        return node && node.nodeName.toUpperCase() === nodeName;
      };
    };

    /**
     * @method isText
     *
     *
     *
     * @param {Node} node
     * @return {Boolean} true if node's type is text(3)
     */
    var isText = function (node) {
      return node && node.nodeType === 3;
    };

    /**
     * @method isElement
     *
     *
     *
     * @param {Node} node
     * @return {Boolean} true if node's type is element(1)
     */
    var isElement = function (node) {
      return node && node.nodeType === 1;
    };

    /**
     * ex) br, col, embed, hr, img, input, ...
     * @see http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
     */
    var isVoid = function (node) {
      return node && /^BR|^IMG|^HR|^IFRAME|^BUTTON/.test(node.nodeName.toUpperCase());
    };

    var isPara = function (node) {
      if (isEditable(node)) {
        return false;
      }

      // Chrome(v31.0), FF(v25.0.1) use DIV for paragraph
      return node && /^DIV|^P|^LI|^H[1-7]/.test(node.nodeName.toUpperCase());
    };

    var isHeading = function (node) {
      return node && /^H[1-7]/.test(node.nodeName.toUpperCase());
    };

    var isPre = makePredByNodeName('PRE');

    var isLi = makePredByNodeName('LI');

    var isPurePara = function (node) {
      return isPara(node) && !isLi(node);
    };

    var isTable = makePredByNodeName('TABLE');

    var isData = makePredByNodeName('DATA');

    var isInline = function (node) {
      return !isBodyContainer(node) &&
             !isList(node) &&
             !isHr(node) &&
             !isPara(node) &&
             !isTable(node) &&
             !isBlockquote(node) &&
             !isData(node);
    };

    var isList = function (node) {
      return node && /^UL|^OL/.test(node.nodeName.toUpperCase());
    };

    var isHr = makePredByNodeName('HR');

    var isCell = function (node) {
      return node && /^TD|^TH/.test(node.nodeName.toUpperCase());
    };

    var isBlockquote = makePredByNodeName('BLOCKQUOTE');

    var isBodyContainer = function (node) {
      return isCell(node) || isBlockquote(node) || isEditable(node);
    };

    var isAnchor = makePredByNodeName('A');

    var isParaInline = function (node) {
      return isInline(node) && !!ancestor(node, isPara);
    };

    var isBodyInline = function (node) {
      return isInline(node) && !ancestor(node, isPara);
    };

    var isBody = makePredByNodeName('BODY');

    /**
     * returns whether nodeB is closest sibling of nodeA
     *
     * @param {Node} nodeA
     * @param {Node} nodeB
     * @return {Boolean}
     */
    var isClosestSibling = function (nodeA, nodeB) {
      return nodeA.nextSibling === nodeB ||
             nodeA.previousSibling === nodeB;
    };

    /**
     * returns array of closest siblings with node
     *
     * @param {Node} node
     * @param {function} [pred] - predicate function
     * @return {Node[]}
     */
    var withClosestSiblings = function (node, pred) {
      pred = pred || func.ok;

      var siblings = [];
      if (node.previousSibling && pred(node.previousSibling)) {
        siblings.push(node.previousSibling);
      }
      siblings.push(node);
      if (node.nextSibling && pred(node.nextSibling)) {
        siblings.push(node.nextSibling);
      }
      return siblings;
    };

    /**
     * blank HTML for cursor position
     * - [workaround] old IE only works with &nbsp;
     * - [workaround] IE11 and other browser works with bogus br
     */
    var blankHTML = agent.isMSIE && agent.browserVersion < 11 ? '&nbsp;' : '<br>';

    /**
     * @method nodeLength
     *
     * returns #text's text size or element's childNodes size
     *
     * @param {Node} node
     */
    var nodeLength = function (node) {
      if (isText(node)) {
        return node.nodeValue.length;
      }

      if (node) {
        return node.childNodes.length;
      }

      return 0;

    };

    /**
     * returns whether node is empty or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    var isEmpty = function (node) {
      var len = nodeLength(node);

      if (len === 0) {
        return true;
      } else if (!isText(node) && len === 1 && node.innerHTML === blankHTML) {
        // ex) <p><br></p>, <span><br></span>
        return true;
      } else if (list.all(node.childNodes, isText) && node.innerHTML === '') {
        // ex) <p></p>, <span></span>
        return true;
      }

      return false;
    };

    /**
     * padding blankHTML if node is empty (for cursor position)
     */
    var paddingBlankHTML = function (node) {
      if (!isVoid(node) && !nodeLength(node)) {
        node.innerHTML = blankHTML;
      }
    };

    /**
     * find nearest ancestor predicate hit
     *
     * @param {Node} node
     * @param {Function} pred - predicate function
     */
    var ancestor = function (node, pred) {
      while (node) {
        if (pred(node)) { return node; }
        if (isEditable(node)) { break; }

        node = node.parentNode;
      }
      return null;
    };

    /**
     * find nearest ancestor only single child blood line and predicate hit
     *
     * @param {Node} node
     * @param {Function} pred - predicate function
     */
    var singleChildAncestor = function (node, pred) {
      node = node.parentNode;

      while (node) {
        if (nodeLength(node) !== 1) { break; }
        if (pred(node)) { return node; }
        if (isEditable(node)) { break; }

        node = node.parentNode;
      }
      return null;
    };

    /**
     * returns new array of ancestor nodes (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [optional] pred - predicate function
     */
    var listAncestor = function (node, pred) {
      pred = pred || func.fail;

      var ancestors = [];
      ancestor(node, function (el) {
        if (!isEditable(el)) {
          ancestors.push(el);
        }

        return pred(el);
      });
      return ancestors;
    };

    /**
     * find farthest ancestor predicate hit
     */
    var lastAncestor = function (node, pred) {
      var ancestors = listAncestor(node);
      return list.last(ancestors.filter(pred));
    };

    /**
     * returns common ancestor node between two nodes.
     *
     * @param {Node} nodeA
     * @param {Node} nodeB
     */
    var commonAncestor = function (nodeA, nodeB) {
      var ancestors = listAncestor(nodeA);
      for (var n = nodeB; n; n = n.parentNode) {
        if ($.inArray(n, ancestors) > -1) { return n; }
      }
      return null; // difference document area
    };

    /**
     * listing all previous siblings (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [optional] pred - predicate function
     */
    var listPrev = function (node, pred) {
      pred = pred || func.fail;

      var nodes = [];
      while (node) {
        if (pred(node)) { break; }
        nodes.push(node);
        node = node.previousSibling;
      }
      return nodes;
    };

    /**
     * listing next siblings (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [pred] - predicate function
     */
    var listNext = function (node, pred) {
      pred = pred || func.fail;

      var nodes = [];
      while (node) {
        if (pred(node)) { break; }
        nodes.push(node);
        node = node.nextSibling;
      }
      return nodes;
    };

    /**
     * listing descendant nodes
     *
     * @param {Node} node
     * @param {Function} [pred] - predicate function
     */
    var listDescendant = function (node, pred) {
      var descendants = [];
      pred = pred || func.ok;

      // start DFS(depth first search) with node
      (function fnWalk(current) {
        if (node !== current && pred(current)) {
          descendants.push(current);
        }
        for (var idx = 0, len = current.childNodes.length; idx < len; idx++) {
          fnWalk(current.childNodes[idx]);
        }
      })(node);

      return descendants;
    };

    /**
     * wrap node with new tag.
     *
     * @param {Node} node
     * @param {Node} tagName of wrapper
     * @return {Node} - wrapper
     */
    var wrap = function (node, wrapperName) {
      var parent = node.parentNode;
      var wrapper = $('<' + wrapperName + '>')[0];

      parent.insertBefore(wrapper, node);
      wrapper.appendChild(node);

      return wrapper;
    };

    /**
     * insert node after preceding
     *
     * @param {Node} node
     * @param {Node} preceding - predicate function
     */
    var insertAfter = function (node, preceding) {
      var next = preceding.nextSibling, parent = preceding.parentNode;
      if (next) {
        parent.insertBefore(node, next);
      } else {
        parent.appendChild(node);
      }
      return node;
    };

    /**
     * append elements.
     *
     * @param {Node} node
     * @param {Collection} aChild
     */
    var appendChildNodes = function (node, aChild) {
      $.each(aChild, function (idx, child) {
        node.appendChild(child);
      });
      return node;
    };

    /**
     * returns whether boundaryPoint is left edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    var isLeftEdgePoint = function (point) {
      return point.offset === 0;
    };

    /**
     * returns whether boundaryPoint is right edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    var isRightEdgePoint = function (point) {
      return point.offset === nodeLength(point.node);
    };

    /**
     * returns whether boundaryPoint is edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    var isEdgePoint = function (point) {
      return isLeftEdgePoint(point) || isRightEdgePoint(point);
    };

    /**
     * returns whether node is left edge of ancestor or not.
     *
     * @param {Node} node
     * @param {Node} ancestor
     * @return {Boolean}
     */
    var isLeftEdgeOf = function (node, ancestor) {
      while (node && node !== ancestor) {
        if (position(node) !== 0) {
          return false;
        }
        node = node.parentNode;
      }

      return true;
    };

    /**
     * returns whether node is right edge of ancestor or not.
     *
     * @param {Node} node
     * @param {Node} ancestor
     * @return {Boolean}
     */
    var isRightEdgeOf = function (node, ancestor) {
      if (!ancestor) {
        return false;
      }
      while (node && node !== ancestor) {
        if (position(node) !== nodeLength(node.parentNode) - 1) {
          return false;
        }
        node = node.parentNode;
      }

      return true;
    };

    /**
     * returns whether point is left edge of ancestor or not.
     * @param {BoundaryPoint} point
     * @param {Node} ancestor
     * @return {Boolean}
     */
    var isLeftEdgePointOf = function (point, ancestor) {
      return isLeftEdgePoint(point) && isLeftEdgeOf(point.node, ancestor);
    };

    /**
     * returns whether point is right edge of ancestor or not.
     * @param {BoundaryPoint} point
     * @param {Node} ancestor
     * @return {Boolean}
     */
    var isRightEdgePointOf = function (point, ancestor) {
      return isRightEdgePoint(point) && isRightEdgeOf(point.node, ancestor);
    };

    /**
     * returns offset from parent.
     *
     * @param {Node} node
     */
    var position = function (node) {
      var offset = 0;
      while ((node = node.previousSibling)) {
        offset += 1;
      }
      return offset;
    };

    var hasChildren = function (node) {
      return !!(node && node.childNodes && node.childNodes.length);
    };

    /**
     * returns previous boundaryPoint
     *
     * @param {BoundaryPoint} point
     * @param {Boolean} isSkipInnerOffset
     * @return {BoundaryPoint}
     */
    var prevPoint = function (point, isSkipInnerOffset) {
      var node, offset;

      if (point.offset === 0) {
        if (isEditable(point.node)) {
          return null;
        }

        node = point.node.parentNode;
        offset = position(point.node);
      } else if (hasChildren(point.node)) {
        node = point.node.childNodes[point.offset - 1];
        offset = nodeLength(node);
      } else {
        node = point.node;
        offset = isSkipInnerOffset ? 0 : point.offset - 1;
      }

      return {
        node: node,
        offset: offset
      };
    };

    /**
     * returns next boundaryPoint
     *
     * @param {BoundaryPoint} point
     * @param {Boolean} isSkipInnerOffset
     * @return {BoundaryPoint}
     */
    var nextPoint = function (point, isSkipInnerOffset) {
      var node, offset;

      if (nodeLength(point.node) === point.offset) {
        if (isEditable(point.node)) {
          return null;
        }

        node = point.node.parentNode;
        offset = position(point.node) + 1;
      } else if (hasChildren(point.node)) {
        node = point.node.childNodes[point.offset];
        offset = 0;
      } else {
        node = point.node;
        offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
      }

      return {
        node: node,
        offset: offset
      };
    };

    /**
     * returns whether pointA and pointB is same or not.
     *
     * @param {BoundaryPoint} pointA
     * @param {BoundaryPoint} pointB
     * @return {Boolean}
     */
    var isSamePoint = function (pointA, pointB) {
      return pointA.node === pointB.node && pointA.offset === pointB.offset;
    };

    /**
     * returns whether point is visible (can set cursor) or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    var isVisiblePoint = function (point) {
      if (isText(point.node) || !hasChildren(point.node) || isEmpty(point.node)) {
        return true;
      }

      var leftNode = point.node.childNodes[point.offset - 1];
      var rightNode = point.node.childNodes[point.offset];
      if ((!leftNode || isVoid(leftNode)) && (!rightNode || isVoid(rightNode))) {
        return true;
      }

      return false;
    };

    /**
     * @method prevPointUtil
     *
     * @param {BoundaryPoint} point
     * @param {Function} pred
     * @return {BoundaryPoint}
     */
    var prevPointUntil = function (point, pred) {
      while (point) {
        if (pred(point)) {
          return point;
        }

        point = prevPoint(point);
      }

      return null;
    };

    /**
     * @method nextPointUntil
     *
     * @param {BoundaryPoint} point
     * @param {Function} pred
     * @return {BoundaryPoint}
     */
    var nextPointUntil = function (point, pred) {
      while (point) {
        if (pred(point)) {
          return point;
        }

        point = nextPoint(point);
      }

      return null;
    };

    /**
     * returns whether point has character or not.
     *
     * @param {Point} point
     * @return {Boolean}
     */
    var isCharPoint = function (point) {
      if (!isText(point.node)) {
        return false;
      }

      var ch = point.node.nodeValue.charAt(point.offset - 1);
      return ch && (ch !== ' ' && ch !== NBSP_CHAR);
    };

    /**
     * @method walkPoint
     *
     * @param {BoundaryPoint} startPoint
     * @param {BoundaryPoint} endPoint
     * @param {Function} handler
     * @param {Boolean} isSkipInnerOffset
     */
    var walkPoint = function (startPoint, endPoint, handler, isSkipInnerOffset) {
      var point = startPoint;

      while (point) {
        handler(point);

        if (isSamePoint(point, endPoint)) {
          break;
        }

        var isSkipOffset = isSkipInnerOffset &&
                           startPoint.node !== point.node &&
                           endPoint.node !== point.node;
        point = nextPoint(point, isSkipOffset);
      }
    };

    /**
     * @method makeOffsetPath
     *
     * return offsetPath(array of offset) from ancestor
     *
     * @param {Node} ancestor - ancestor node
     * @param {Node} node
     */
    var makeOffsetPath = function (ancestor, node) {
      var ancestors = listAncestor(node, func.eq(ancestor));
      return ancestors.map(position).reverse();
    };

    /**
     * @method fromOffsetPath
     *
     * return element from offsetPath(array of offset)
     *
     * @param {Node} ancestor - ancestor node
     * @param {array} offsets - offsetPath
     */
    var fromOffsetPath = function (ancestor, offsets) {
      var current = ancestor;
      for (var i = 0, len = offsets.length; i < len; i++) {
        if (current.childNodes.length <= offsets[i]) {
          current = current.childNodes[current.childNodes.length - 1];
        } else {
          current = current.childNodes[offsets[i]];
        }
      }
      return current;
    };

    /**
     * @method splitNode
     *
     * split element or #text
     *
     * @param {BoundaryPoint} point
     * @param {Object} [options]
     * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
     * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
     * @return {Node} right node of boundaryPoint
     */
    var splitNode = function (point, options) {
      var isSkipPaddingBlankHTML = options && options.isSkipPaddingBlankHTML;
      var isNotSplitEdgePoint = options && options.isNotSplitEdgePoint;

      // edge case
      if (isEdgePoint(point) && (isText(point.node) || isNotSplitEdgePoint)) {
        if (isLeftEdgePoint(point)) {
          return point.node;
        } else if (isRightEdgePoint(point)) {
          return point.node.nextSibling;
        }
      }

      // split #text
      if (isText(point.node)) {
        return point.node.splitText(point.offset);
      } else {
        var childNode = point.node.childNodes[point.offset];
        var clone = insertAfter(point.node.cloneNode(false), point.node);
        appendChildNodes(clone, listNext(childNode));

        if (!isSkipPaddingBlankHTML) {
          paddingBlankHTML(point.node);
          paddingBlankHTML(clone);
        }

        return clone;
      }
    };

    /**
     * @method splitTree
     *
     * split tree by point
     *
     * @param {Node} root - split root
     * @param {BoundaryPoint} point
     * @param {Object} [options]
     * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
     * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
     * @return {Node} right node of boundaryPoint
     */
    var splitTree = function (root, point, options) {
      // ex) [#text, <span>, <p>]
      var ancestors = listAncestor(point.node, func.eq(root));

      if (!ancestors.length) {
        return null;
      } else if (ancestors.length === 1) {
        return splitNode(point, options);
      }

      return ancestors.reduce(function (node, parent) {
        if (node === point.node) {
          node = splitNode(point, options);
        }

        return splitNode({
          node: parent,
          offset: node ? dom.position(node) : nodeLength(parent)
        }, options);
      });
    };

    /**
     * split point
     *
     * @param {Point} point
     * @param {Boolean} isInline
     * @return {Object}
     */
    var splitPoint = function (point, isInline) {
      // find splitRoot, container
      //  - inline: splitRoot is a child of paragraph
      //  - block: splitRoot is a child of bodyContainer
      var pred = isInline ? isPara : isBodyContainer;
      var ancestors = listAncestor(point.node, pred);
      var topAncestor = list.last(ancestors) || point.node;

      var splitRoot, container;
      if (pred(topAncestor)) {
        splitRoot = ancestors[ancestors.length - 2];
        container = topAncestor;
      } else {
        splitRoot = topAncestor;
        container = splitRoot.parentNode;
      }

      // if splitRoot is exists, split with splitTree
      var pivot = splitRoot && splitTree(splitRoot, point, {
        isSkipPaddingBlankHTML: isInline,
        isNotSplitEdgePoint: isInline
      });

      // if container is point.node, find pivot with point.offset
      if (!pivot && container === point.node) {
        pivot = point.node.childNodes[point.offset];
      }

      return {
        rightNode: pivot,
        container: container
      };
    };

    var create = function (nodeName) {
      return document.createElement(nodeName);
    };

    var createText = function (text) {
      return document.createTextNode(text);
    };

    /**
     * @method remove
     *
     * remove node, (isRemoveChild: remove child or not)
     *
     * @param {Node} node
     * @param {Boolean} isRemoveChild
     */
    var remove = function (node, isRemoveChild) {
      if (!node || !node.parentNode) { return; }
      if (node.removeNode) { return node.removeNode(isRemoveChild); }

      var parent = node.parentNode;
      if (!isRemoveChild) {
        var nodes = [];
        var i, len;
        for (i = 0, len = node.childNodes.length; i < len; i++) {
          nodes.push(node.childNodes[i]);
        }

        for (i = 0, len = nodes.length; i < len; i++) {
          parent.insertBefore(nodes[i], node);
        }
      }

      parent.removeChild(node);
    };

    /**
     * @method removeWhile
     *
     * @param {Node} node
     * @param {Function} pred
     */
    var removeWhile = function (node, pred) {
      while (node) {
        if (isEditable(node) || !pred(node)) {
          break;
        }

        var parent = node.parentNode;
        remove(node);
        node = parent;
      }
    };

    /**
     * @method replace
     *
     * replace node with provided nodeName
     *
     * @param {Node} node
     * @param {String} nodeName
     * @return {Node} - new node
     */
    var replace = function (node, nodeName) {
      if (node.nodeName.toUpperCase() === nodeName.toUpperCase()) {
        return node;
      }

      var newNode = create(nodeName);

      if (node.style.cssText) {
        newNode.style.cssText = node.style.cssText;
      }

      appendChildNodes(newNode, list.from(node.childNodes));
      insertAfter(newNode, node);
      remove(node);

      return newNode;
    };

    var isTextarea = makePredByNodeName('TEXTAREA');

    /**
     * @param {jQuery} $node
     * @param {Boolean} [stripLinebreaks] - default: false
     */
    var value = function ($node, stripLinebreaks) {
      var val = isTextarea($node[0]) ? $node.val() : $node.html();
      if (stripLinebreaks) {
        return val.replace(/[\n\r]/g, '');
      }
      return val;
    };

    /**
     * @method html
     *
     * get the HTML contents of node
     *
     * @param {jQuery} $node
     * @param {Boolean} [isNewlineOnBlock]
     */
    var html = function ($node, isNewlineOnBlock) {
      var markup = value($node);

      if (isNewlineOnBlock) {
        var regexTag = /<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g;
        markup = markup.replace(regexTag, function (match, endSlash, name) {
          name = name.toUpperCase();
          var isEndOfInlineContainer = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(name) &&
                                       !!endSlash;
          var isBlockNode = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(name);

          return match + ((isEndOfInlineContainer || isBlockNode) ? '\n' : '');
        });
        markup = $.trim(markup);
      }

      return markup;
    };

    var posFromPlaceholder = function (placeholder) {
      var $placeholder = $(placeholder);
      var pos = $placeholder.offset();
      var height = $placeholder.outerHeight(true); // include margin

      return {
        left: pos.left,
        top: pos.top + height
      };
    };

    var attachEvents = function ($node, events) {
      Object.keys(events).forEach(function (key) {
        $node.on(key, events[key]);
      });
    };

    var detachEvents = function ($node, events) {
      Object.keys(events).forEach(function (key) {
        $node.off(key, events[key]);
      });
    };

    return {
      /** @property {String} NBSP_CHAR */
      NBSP_CHAR: NBSP_CHAR,
      /** @property {String} ZERO_WIDTH_NBSP_CHAR */
      ZERO_WIDTH_NBSP_CHAR: ZERO_WIDTH_NBSP_CHAR,
      /** @property {String} blank */
      blank: blankHTML,
      /** @property {String} emptyPara */
      emptyPara: '<p>' + blankHTML + '</p>',
      makePredByNodeName: makePredByNodeName,
      isEditable: isEditable,
      isControlSizing: isControlSizing,
      isText: isText,
      isElement: isElement,
      isVoid: isVoid,
      isPara: isPara,
      isPurePara: isPurePara,
      isHeading: isHeading,
      isInline: isInline,
      isBlock: func.not(isInline),
      isBodyInline: isBodyInline,
      isBody: isBody,
      isParaInline: isParaInline,
      isPre: isPre,
      isList: isList,
      isTable: isTable,
      isData: isData,
      isCell: isCell,
      isBlockquote: isBlockquote,
      isBodyContainer: isBodyContainer,
      isAnchor: isAnchor,
      isDiv: makePredByNodeName('DIV'),
      isLi: isLi,
      isBR: makePredByNodeName('BR'),
      isSpan: makePredByNodeName('SPAN'),
      isB: makePredByNodeName('B'),
      isU: makePredByNodeName('U'),
      isS: makePredByNodeName('S'),
      isI: makePredByNodeName('I'),
      isImg: makePredByNodeName('IMG'),
      isTextarea: isTextarea,
      isEmpty: isEmpty,
      isEmptyAnchor: func.and(isAnchor, isEmpty),
      isClosestSibling: isClosestSibling,
      withClosestSiblings: withClosestSiblings,
      nodeLength: nodeLength,
      isLeftEdgePoint: isLeftEdgePoint,
      isRightEdgePoint: isRightEdgePoint,
      isEdgePoint: isEdgePoint,
      isLeftEdgeOf: isLeftEdgeOf,
      isRightEdgeOf: isRightEdgeOf,
      isLeftEdgePointOf: isLeftEdgePointOf,
      isRightEdgePointOf: isRightEdgePointOf,
      prevPoint: prevPoint,
      nextPoint: nextPoint,
      isSamePoint: isSamePoint,
      isVisiblePoint: isVisiblePoint,
      prevPointUntil: prevPointUntil,
      nextPointUntil: nextPointUntil,
      isCharPoint: isCharPoint,
      walkPoint: walkPoint,
      ancestor: ancestor,
      singleChildAncestor: singleChildAncestor,
      listAncestor: listAncestor,
      lastAncestor: lastAncestor,
      listNext: listNext,
      listPrev: listPrev,
      listDescendant: listDescendant,
      commonAncestor: commonAncestor,
      wrap: wrap,
      insertAfter: insertAfter,
      appendChildNodes: appendChildNodes,
      position: position,
      hasChildren: hasChildren,
      makeOffsetPath: makeOffsetPath,
      fromOffsetPath: fromOffsetPath,
      splitTree: splitTree,
      splitPoint: splitPoint,
      create: create,
      createText: createText,
      remove: remove,
      removeWhile: removeWhile,
      replace: replace,
      html: html,
      value: value,
      posFromPlaceholder: posFromPlaceholder,
      attachEvents: attachEvents,
      detachEvents: detachEvents
    };
  })();

  /**
   * @param {jQuery} $note
   * @param {Object} options
   * @return {Context}
   */
  var Context = function ($note, options) {
    var self = this;

    var ui = $.summernote.ui;
    this.memos = {};
    this.modules = {};
    this.layoutInfo = {};
    this.options = options;

    /**
     * create layout and initialize modules and other resources
     */
    this.initialize = function () {
      this.layoutInfo = ui.createLayout($note, options);
      this._initialize();
      $note.hide();
      return this;
    };

    /**
     * destroy modules and other resources and remove layout
     */
    this.destroy = function () {
      this._destroy();
      $note.removeData('summernote');
      ui.removeLayout($note, this.layoutInfo);
    };

    /**
     * destory modules and other resources and initialize it again
     */
    this.reset = function () {
      var disabled = self.isDisabled();
      this.code(dom.emptyPara);
      this._destroy();
      this._initialize();

      if (disabled) {
        self.disable();
      }
    };

    this._initialize = function () {
      // add optional buttons
      var buttons = $.extend({}, this.options.buttons);
      Object.keys(buttons).forEach(function (key) {
        self.memo('button.' + key, buttons[key]);
      });

      var modules = $.extend({}, this.options.modules, $.summernote.plugins || {});

      // add and initialize modules
      Object.keys(modules).forEach(function (key) {
        self.module(key, modules[key], true);
      });

      Object.keys(this.modules).forEach(function (key) {
        self.initializeModule(key);
      });
    };

    this._destroy = function () {
      // destroy modules with reversed order
      Object.keys(this.modules).reverse().forEach(function (key) {
        self.removeModule(key);
      });

      Object.keys(this.memos).forEach(function (key) {
        self.removeMemo(key);
      });
    };

    this.code = function (html) {
      var isActivated = this.invoke('codeview.isActivated');

      if (html === undefined) {
        this.invoke('codeview.sync');
        return isActivated ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
      } else {
        if (isActivated) {
          this.layoutInfo.codable.val(html);
        } else {
          this.layoutInfo.editable.html(html);
        }
        $note.val(html);
        this.triggerEvent('change', html);
      }
    };

    this.isDisabled = function () {
      return this.layoutInfo.editable.attr('contenteditable') === 'false';
    };

    this.enable = function () {
      this.layoutInfo.editable.attr('contenteditable', true);
      this.invoke('toolbar.activate', true);
    };

    this.disable = function () {
      // close codeview if codeview is opend
      if (this.invoke('codeview.isActivated')) {
        this.invoke('codeview.deactivate');
      }
      this.layoutInfo.editable.attr('contenteditable', false);
      this.invoke('toolbar.deactivate', true);
    };

    this.triggerEvent = function () {
      var namespace = list.head(arguments);
      var args = list.tail(list.from(arguments));

      var callback = this.options.callbacks[func.namespaceToCamel(namespace, 'on')];
      if (callback) {
        callback.apply($note[0], args);
      }
      $note.trigger('summernote.' + namespace, args);
    };

    this.initializeModule = function (key) {
      var module = this.modules[key];
      module.shouldInitialize = module.shouldInitialize || func.ok;
      if (!module.shouldInitialize()) {
        return;
      }

      // initialize module
      if (module.initialize) {
        module.initialize();
      }

      // attach events
      if (module.events) {
        dom.attachEvents($note, module.events);
      }
    };

    this.module = function (key, ModuleClass, withoutIntialize) {
      if (arguments.length === 1) {
        return this.modules[key];
      }

      this.modules[key] = new ModuleClass(this);

      if (!withoutIntialize) {
        this.initializeModule(key);
      }
    };

    this.removeModule = function (key) {
      var module = this.modules[key];
      if (module.shouldInitialize()) {
        if (module.events) {
          dom.detachEvents($note, module.events);
        }

        if (module.destroy) {
          module.destroy();
        }
      }

      delete this.modules[key];
    };

    this.memo = function (key, obj) {
      if (arguments.length === 1) {
        return this.memos[key];
      }
      this.memos[key] = obj;
    };

    this.removeMemo = function (key) {
      if (this.memos[key] && this.memos[key].destroy) {
        this.memos[key].destroy();
      }

      delete this.memos[key];
    };

    this.createInvokeHandler = function (namespace, value) {
      return function (event) {
        event.preventDefault();
        self.invoke(namespace, value || $(event.target).closest('[data-value]').data('value'));
      };
    };

    this.invoke = function () {
      var namespace = list.head(arguments);
      var args = list.tail(list.from(arguments));

      var splits = namespace.split('.');
      var hasSeparator = splits.length > 1;
      var moduleName = hasSeparator && list.head(splits);
      var methodName = hasSeparator ? list.last(splits) : list.head(splits);

      var module = this.modules[moduleName || 'editor'];
      if (!moduleName && this[methodName]) {
        return this[methodName].apply(this, args);
      } else if (module && module[methodName] && module.shouldInitialize()) {
        return module[methodName].apply(module, args);
      }
    };

    return this.initialize();
  };

  $.fn.extend({
    /**
     * Summernote API
     *
     * @param {Object|String}
     * @return {this}
     */
    summernote: function () {
      var type = $.type(list.head(arguments));
      var isExternalAPICalled = type === 'string';
      var hasInitOptions = type === 'object';

      var options = hasInitOptions ? list.head(arguments) : {};

      options = $.extend({}, $.summernote.options, options);
      options.langInfo = $.extend(true, {}, $.summernote.lang['en-US'], $.summernote.lang[options.lang]);
      options.icons = $.extend(true, {}, $.summernote.options.icons, options.icons);

      this.each(function (idx, note) {
        var $note = $(note);
        if (!$note.data('summernote')) {
          var context = new Context($note, options);
          $note.data('summernote', context);
          $note.data('summernote').triggerEvent('init', context.layoutInfo);
        }
      });

      var $note = this.first();
      if ($note.length) {
        var context = $note.data('summernote');
        if (isExternalAPICalled) {
          return context.invoke.apply(context, list.from(arguments));
        } else if (options.focus) {
          context.invoke('editor.focus');
        }
      }

      return this;
    }
  });


  var Renderer = function (markup, children, options, callback) {
    this.render = function ($parent) {
      var $node = $(markup);

      if (options && options.contents) {
        $node.html(options.contents);
      }

      if (options && options.className) {
        $node.addClass(options.className);
      }

      if (options && options.data) {
        $.each(options.data, function (k, v) {
          $node.attr('data-' + k, v);
        });
      }

      if (options && options.click) {
        $node.on('click', options.click);
      }

      if (children) {
        var $container = $node.find('.note-children-container');
        children.forEach(function (child) {
          child.render($container.length ? $container : $node);
        });
      }

      if (callback) {
        callback($node, options);
      }

      if (options && options.callback) {
        options.callback($node);
      }

      if ($parent) {
        $parent.append($node);
      }

      return $node;
    };
  };

  var renderer = {
    create: function (markup, callback) {
      return function () {
        var children = $.isArray(arguments[0]) ? arguments[0] : [];
        var options = typeof arguments[1] === 'object' ? arguments[1] : arguments[0];
        if (options && options.children) {
          children = options.children;
        }
        return new Renderer(markup, children, options, callback);
      };
    }
  };

  var editor = renderer.create('<div class="note-editor note-frame panel panel-default"/>');
  var toolbar = renderer.create('<div class="note-toolbar panel-heading"/>');
  var editingArea = renderer.create('<div class="note-editing-area"/>');
  var codable = renderer.create('<textarea class="note-codable"/>');
  var editable = renderer.create('<div class="note-editable panel-body" contentEditable="true"/>');
  var statusbar = renderer.create([
    '<div class="note-statusbar">',
    '  <div class="note-resizebar">',
    '    <div class="note-icon-bar"/>',
    '    <div class="note-icon-bar"/>',
    '    <div class="note-icon-bar"/>',
    '  </div>',
    '</div>'
  ].join(''));

  var airEditor = renderer.create('<div class="note-editor"/>');
  var airEditable = renderer.create('<div class="note-editable" contentEditable="true"/>');

  var buttonGroup = renderer.create('<div class="note-btn-group btn-group">');
  var button = renderer.create('<button type="button" class="note-btn btn btn-default btn-sm" tabindex="-1">', function ($node, options) {
    if (options && options.tooltip) {
      $node.attr({
        title: options.tooltip
      }).tooltip({
        container: 'body',
        trigger: 'hover',
        placement: 'bottom'
      });
    }
  });

  var dropdown = renderer.create('<div class="dropdown-menu">', function ($node, options) {
    var markup = $.isArray(options.items) ? options.items.map(function (item) {
      var value = (typeof item === 'string') ? item : (item.value || '');
      var content = options.template ? options.template(item) : item;
      return '<li><a href="#" data-value="' + value + '">' + content + '</a></li>';
    }).join('') : options.items;

    $node.html(markup);
  });

  var dropdownCheck = renderer.create('<div class="dropdown-menu note-check">', function ($node, options) {
    var markup = $.isArray(options.items) ? options.items.map(function (item) {
      var value = (typeof item === 'string') ? item : (item.value || '');
      var content = options.template ? options.template(item) : item;
      return '<li><a href="#" data-value="' + value + '">' + icon(options.checkClassName) + ' ' + content + '</a></li>';
    }).join('') : options.items;
    $node.html(markup);
  });

  var palette = renderer.create('<div class="note-color-palette"/>', function ($node, options) {
    var contents = [];
    for (var row = 0, rowSize = options.colors.length; row < rowSize; row++) {
      var eventName = options.eventName;
      var colors = options.colors[row];
      var buttons = [];
      for (var col = 0, colSize = colors.length; col < colSize; col++) {
        var color = colors[col];
        buttons.push([
          '<button type="button" class="note-color-btn"',
          'style="background-color:', color, '" ',
          'data-event="', eventName, '" ',
          'data-value="', color, '" ',
          'title="', color, '" ',
          'data-toggle="button" tabindex="-1"></button>'
        ].join(''));
      }
      contents.push('<div class="note-color-row">' + buttons.join('') + '</div>');
    }
    $node.html(contents.join(''));

    $node.find('.note-color-btn').tooltip({
      container: 'body',
      trigger: 'hover',
      placement: 'bottom'
    });
  });

  var dialog = renderer.create('<div class="modal" aria-hidden="false" tabindex="-1"/>', function ($node, options) {
    if (options.fade) {
      $node.addClass('fade');
    }
    $node.html([
      '<div class="modal-dialog">',
      '  <div class="modal-content">',
      (options.title ?
      '    <div class="modal-header">' +
      '      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '      <h4 class="modal-title">' + options.title + '</h4>' +
      '    </div>' : ''
      ),
      '    <div class="modal-body">' + options.body + '</div>',
      (options.footer ?
      '    <div class="modal-footer">' + options.footer + '</div>' : ''
      ),
      '  </div>',
      '</div>'
    ].join(''));
  });

  var popover = renderer.create([
    '<div class="note-popover popover in">',
    '  <div class="arrow"/>',
    '  <div class="popover-content note-children-container"/>',
    '</div>'
  ].join(''), function ($node, options) {
    var direction = typeof options.direction !== 'undefined' ? options.direction : 'bottom';

    $node.addClass(direction);

    if (options.hideArrow) {
      $node.find('.arrow').hide();
    }
  });

  var icon = function (iconClassName, tagName) {
    tagName = tagName || 'i';
    return '<' + tagName + ' class="' + iconClassName + '"/>';
  };

  var ui = {
    editor: editor,
    toolbar: toolbar,
    editingArea: editingArea,
    codable: codable,
    editable: editable,
    statusbar: statusbar,
    airEditor: airEditor,
    airEditable: airEditable,
    buttonGroup: buttonGroup,
    button: button,
    dropdown: dropdown,
    dropdownCheck: dropdownCheck,
    palette: palette,
    dialog: dialog,
    popover: popover,
    icon: icon,

    toggleBtn: function ($btn, isEnable) {
      $btn.toggleClass('disabled', !isEnable);
      $btn.attr('disabled', !isEnable);
    },

    toggleBtnActive: function ($btn, isActive) {
      $btn.toggleClass('active', isActive);
    },

    onDialogShown: function ($dialog, handler) {
      $dialog.one('shown.bs.modal', handler);
    },

    onDialogHidden: function ($dialog, handler) {
      $dialog.one('hidden.bs.modal', handler);
    },

    showDialog: function ($dialog) {
      $dialog.modal('show');
    },

    hideDialog: function ($dialog) {
      $dialog.modal('hide');
    },

    createLayout: function ($note, options) {
      var $editor = (options.airMode ? ui.airEditor([
        ui.editingArea([
          ui.airEditable()
        ])
      ]) : ui.editor([
        ui.toolbar(),
        ui.editingArea([
          ui.codable(),
          ui.editable()
        ]),
        ui.statusbar()
      ])).render();

      $editor.insertAfter($note);

      return {
        note: $note,
        editor: $editor,
        toolbar: $editor.find('.note-toolbar'),
        editingArea: $editor.find('.note-editing-area'),
        editable: $editor.find('.note-editable'),
        codable: $editor.find('.note-codable'),
        statusbar: $editor.find('.note-statusbar')
      };
    },

    removeLayout: function ($note, layoutInfo) {
      $note.html(layoutInfo.editable.html());
      layoutInfo.editor.remove();
      $note.show();
    }
  };

  $.summernote = $.summernote || {
    lang: {}
  };

  $.extend($.summernote.lang, {
    'en-US': {
      font: {
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        clear: 'Remove Font Style',
        height: 'Line Height',
        name: 'Font Family',
        strikethrough: 'Strikethrough',
        subscript: 'Subscript',
        superscript: 'Superscript',
        size: 'Font Size'
      },
      image: {
        image: 'Picture',
        insert: 'Insert Image',
        resizeFull: 'Resize Full',
        resizeHalf: 'Resize Half',
        resizeQuarter: 'Resize Quarter',
        floatLeft: 'Float Left',
        floatRight: 'Float Right',
        floatNone: 'Float None',
        shapeRounded: 'Shape: Rounded',
        shapeCircle: 'Shape: Circle',
        shapeThumbnail: 'Shape: Thumbnail',
        shapeNone: 'Shape: None',
        dragImageHere: 'Drag image or text here',
        dropImage: 'Drop image or Text',
        selectFromFiles: 'Select from files',
        maximumFileSize: 'Maximum file size',
        maximumFileSizeError: 'Maximum file size exceeded.',
        url: 'Image URL',
        remove: 'Remove Image'
      },
      video: {
        video: 'Video',
        videoLink: 'Video Link',
        insert: 'Insert Video',
        url: 'Video URL?',
        providers: '(YouTube, Vimeo, Vine, Instagram, DailyMotion or Youku)'
      },
      link: {
        link: 'Link',
        insert: 'Insert Link',
        unlink: 'Unlink',
        edit: 'Edit',
        textToDisplay: 'Text to display',
        url: 'To what URL should this link go?',
        openInNewWindow: 'Open in new window'
      },
      table: {
        table: 'Table'
      },
      hr: {
        insert: 'Insert Horizontal Rule'
      },
      style: {
        style: 'Style',
        normal: 'Normal',
        blockquote: 'Quote',
        pre: 'Code',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6'
      },
      lists: {
        unordered: 'Unordered list',
        ordered: 'Ordered list'
      },
      options: {
        help: 'Help',
        fullscreen: 'Full Screen',
        codeview: 'Code View'
      },
      paragraph: {
        paragraph: 'Paragraph',
        outdent: 'Outdent',
        indent: 'Indent',
        left: 'Align left',
        center: 'Align center',
        right: 'Align right',
        justify: 'Justify full'
      },
      color: {
        recent: 'Recent Color',
        more: 'More Color',
        background: 'Background Color',
        foreground: 'Foreground Color',
        transparent: 'Transparent',
        setTransparent: 'Set transparent',
        reset: 'Reset',
        resetToDefault: 'Reset to default'
      },
      shortcut: {
        shortcuts: 'Keyboard shortcuts',
        close: 'Close',
        textFormatting: 'Text formatting',
        action: 'Action',
        paragraphFormatting: 'Paragraph formatting',
        documentStyle: 'Document Style',
        extraKeys: 'Extra keys'
      },
      help: {
        'insertParagraph': 'Insert Paragraph',
        'undo': 'Undoes the last command',
        'redo': 'Redoes the last command',
        'tab': 'Tab',
        'untab': 'Untab',
        'bold': 'Set a bold style',
        'italic': 'Set a italic style',
        'underline': 'Set a underline style',
        'strikethrough': 'Set a strikethrough style',
        'removeFormat': 'Clean a style',
        'justifyLeft': 'Set left align',
        'justifyCenter': 'Set center align',
        'justifyRight': 'Set right align',
        'justifyFull': 'Set full align',
        'insertUnorderedList': 'Toggle unordered list',
        'insertOrderedList': 'Toggle ordered list',
        'outdent': 'Outdent on current paragraph',
        'indent': 'Indent on current paragraph',
        'formatPara': 'Change current block\'s format as a paragraph(P tag)',
        'formatH1': 'Change current block\'s format as H1',
        'formatH2': 'Change current block\'s format as H2',
        'formatH3': 'Change current block\'s format as H3',
        'formatH4': 'Change current block\'s format as H4',
        'formatH5': 'Change current block\'s format as H5',
        'formatH6': 'Change current block\'s format as H6',
        'insertHorizontalRule': 'Insert horizontal rule',
        'linkDialog.show': 'Show Link Dialog'
      },
      history: {
        undo: 'Undo',
        redo: 'Redo'
      },
      specialChar: {
        specialChar: 'SPECIAL CHARACTERS',
        select: 'Select Special characters'
      }
    }
  });


  /**
   * @class core.key
   *
   * Object for keycodes.
   *
   * @singleton
   * @alternateClassName key
   */
  var key = (function () {
    var keyMap = {
      'BACKSPACE': 8,
      'TAB': 9,
      'ENTER': 13,
      'SPACE': 32,

      // Arrow
      'LEFT': 37,
      'UP': 38,
      'RIGHT': 39,
      'DOWN': 40,

      // Number: 0-9
      'NUM0': 48,
      'NUM1': 49,
      'NUM2': 50,
      'NUM3': 51,
      'NUM4': 52,
      'NUM5': 53,
      'NUM6': 54,
      'NUM7': 55,
      'NUM8': 56,

      // Alphabet: a-z
      'B': 66,
      'E': 69,
      'I': 73,
      'J': 74,
      'K': 75,
      'L': 76,
      'R': 82,
      'S': 83,
      'U': 85,
      'V': 86,
      'Y': 89,
      'Z': 90,

      'SLASH': 191,
      'LEFTBRACKET': 219,
      'BACKSLASH': 220,
      'RIGHTBRACKET': 221
    };

    return {
      /**
       * @method isEdit
       *
       * @param {Number} keyCode
       * @return {Boolean}
       */
      isEdit: function (keyCode) {
        return list.contains([
          keyMap.BACKSPACE,
          keyMap.TAB,
          keyMap.ENTER,
          keyMap.SPACE
        ], keyCode);
      },
      /**
       * @method isMove
       *
       * @param {Number} keyCode
       * @return {Boolean}
       */
      isMove: function (keyCode) {
        return list.contains([
          keyMap.LEFT,
          keyMap.UP,
          keyMap.RIGHT,
          keyMap.DOWN
        ], keyCode);
      },
      /**
       * @property {Object} nameFromCode
       * @property {String} nameFromCode.8 "BACKSPACE"
       */
      nameFromCode: func.invertObject(keyMap),
      code: keyMap
    };
  })();

  var range = (function () {

    /**
     * return boundaryPoint from TextRange, inspired by Andy Na's HuskyRange.js
     *
     * @param {TextRange} textRange
     * @param {Boolean} isStart
     * @return {BoundaryPoint}
     *
     * @see http://msdn.microsoft.com/en-us/library/ie/ms535872(v=vs.85).aspx
     */
    var textRangeToPoint = function (textRange, isStart) {
      var container = textRange.parentElement(), offset;

      var tester = document.body.createTextRange(), prevContainer;
      var childNodes = list.from(container.childNodes);
      for (offset = 0; offset < childNodes.length; offset++) {
        if (dom.isText(childNodes[offset])) {
          continue;
        }
        tester.moveToElementText(childNodes[offset]);
        if (tester.compareEndPoints('StartToStart', textRange) >= 0) {
          break;
        }
        prevContainer = childNodes[offset];
      }

      if (offset !== 0 && dom.isText(childNodes[offset - 1])) {
        var textRangeStart = document.body.createTextRange(), curTextNode = null;
        textRangeStart.moveToElementText(prevContainer || container);
        textRangeStart.collapse(!prevContainer);
        curTextNode = prevContainer ? prevContainer.nextSibling : container.firstChild;

        var pointTester = textRange.duplicate();
        pointTester.setEndPoint('StartToStart', textRangeStart);
        var textCount = pointTester.text.replace(/[\r\n]/g, '').length;

        while (textCount > curTextNode.nodeValue.length && curTextNode.nextSibling) {
          textCount -= curTextNode.nodeValue.length;
          curTextNode = curTextNode.nextSibling;
        }

        /* jshint ignore:start */
        var dummy = curTextNode.nodeValue; // enforce IE to re-reference curTextNode, hack
        /* jshint ignore:end */

        if (isStart && curTextNode.nextSibling && dom.isText(curTextNode.nextSibling) &&
            textCount === curTextNode.nodeValue.length) {
          textCount -= curTextNode.nodeValue.length;
          curTextNode = curTextNode.nextSibling;
        }

        container = curTextNode;
        offset = textCount;
      }

      return {
        cont: container,
        offset: offset
      };
    };

    /**
     * return TextRange from boundary point (inspired by google closure-library)
     * @param {BoundaryPoint} point
     * @return {TextRange}
     */
    var pointToTextRange = function (point) {
      var textRangeInfo = function (container, offset) {
        var node, isCollapseToStart;

        if (dom.isText(container)) {
          var prevTextNodes = dom.listPrev(container, func.not(dom.isText));
          var prevContainer = list.last(prevTextNodes).previousSibling;
          node =  prevContainer || container.parentNode;
          offset += list.sum(list.tail(prevTextNodes), dom.nodeLength);
          isCollapseToStart = !prevContainer;
        } else {
          node = container.childNodes[offset] || container;
          if (dom.isText(node)) {
            return textRangeInfo(node, 0);
          }

          offset = 0;
          isCollapseToStart = false;
        }

        return {
          node: node,
          collapseToStart: isCollapseToStart,
          offset: offset
        };
      };

      var textRange = document.body.createTextRange();
      var info = textRangeInfo(point.node, point.offset);

      textRange.moveToElementText(info.node);
      textRange.collapse(info.collapseToStart);
      textRange.moveStart('character', info.offset);
      return textRange;
    };

    /**
     * Wrapped Range
     *
     * @constructor
     * @param {Node} sc - start container
     * @param {Number} so - start offset
     * @param {Node} ec - end container
     * @param {Number} eo - end offset
     */
    var WrappedRange = function (sc, so, ec, eo) {
      this.sc = sc;
      this.so = so;
      this.ec = ec;
      this.eo = eo;

      // nativeRange: get nativeRange from sc, so, ec, eo
      var nativeRange = function () {
        if (agent.isW3CRangeSupport) {
          var w3cRange = document.createRange();
          w3cRange.setStart(sc, so);
          w3cRange.setEnd(ec, eo);

          return w3cRange;
        } else {
          var textRange = pointToTextRange({
            node: sc,
            offset: so
          });

          textRange.setEndPoint('EndToEnd', pointToTextRange({
            node: ec,
            offset: eo
          }));

          return textRange;
        }
      };

      this.getPoints = function () {
        return {
          sc: sc,
          so: so,
          ec: ec,
          eo: eo
        };
      };

      this.getStartPoint = function () {
        return {
          node: sc,
          offset: so
        };
      };

      this.getEndPoint = function () {
        return {
          node: ec,
          offset: eo
        };
      };

      /**
       * select update visible range
       */
      this.select = function () {
        var nativeRng = nativeRange();
        if (agent.isW3CRangeSupport) {
          var selection = document.getSelection();
          if (selection.rangeCount > 0) {
            selection.removeAllRanges();
          }
          selection.addRange(nativeRng);
        } else {
          nativeRng.select();
        }

        return this;
      };

      /**
       * Moves the scrollbar to start container(sc) of current range
       *
       * @return {WrappedRange}
       */
      this.scrollIntoView = function (container) {
        var height = $(container).height();
        if (container.scrollTop + height < this.sc.offsetTop) {
          container.scrollTop += Math.abs(container.scrollTop + height - this.sc.offsetTop);
        }

        return this;
      };

      /**
       * @return {WrappedRange}
       */
      this.normalize = function () {

        /**
         * @param {BoundaryPoint} point
         * @param {Boolean} isLeftToRight
         * @return {BoundaryPoint}
         */
        var getVisiblePoint = function (point, isLeftToRight) {
          if ((dom.isVisiblePoint(point) && !dom.isEdgePoint(point)) ||
              (dom.isVisiblePoint(point) && dom.isRightEdgePoint(point) && !isLeftToRight) ||
              (dom.isVisiblePoint(point) && dom.isLeftEdgePoint(point) && isLeftToRight) ||
              (dom.isVisiblePoint(point) && dom.isBlock(point.node) && dom.isEmpty(point.node))) {
            return point;
          }

          // point on block's edge
          var block = dom.ancestor(point.node, dom.isBlock);
          if (((dom.isLeftEdgePointOf(point, block) || dom.isVoid(dom.prevPoint(point).node)) && !isLeftToRight) ||
              ((dom.isRightEdgePointOf(point, block) || dom.isVoid(dom.nextPoint(point).node)) && isLeftToRight)) {

            // returns point already on visible point
            if (dom.isVisiblePoint(point)) {
              return point;
            }
            // reverse direction
            isLeftToRight = !isLeftToRight;
          }

          var nextPoint = isLeftToRight ? dom.nextPointUntil(dom.nextPoint(point), dom.isVisiblePoint) :
                                          dom.prevPointUntil(dom.prevPoint(point), dom.isVisiblePoint);
          return nextPoint || point;
        };

        var endPoint = getVisiblePoint(this.getEndPoint(), false);
        var startPoint = this.isCollapsed() ? endPoint : getVisiblePoint(this.getStartPoint(), true);

        return new WrappedRange(
          startPoint.node,
          startPoint.offset,
          endPoint.node,
          endPoint.offset
        );
      };

      /**
       * returns matched nodes on range
       *
       * @param {Function} [pred] - predicate function
       * @param {Object} [options]
       * @param {Boolean} [options.includeAncestor]
       * @param {Boolean} [options.fullyContains]
       * @return {Node[]}
       */
      this.nodes = function (pred, options) {
        pred = pred || func.ok;

        var includeAncestor = options && options.includeAncestor;
        var fullyContains = options && options.fullyContains;

        // TODO compare points and sort
        var startPoint = this.getStartPoint();
        var endPoint = this.getEndPoint();

        var nodes = [];
        var leftEdgeNodes = [];

        dom.walkPoint(startPoint, endPoint, function (point) {
          if (dom.isEditable(point.node)) {
            return;
          }

          var node;
          if (fullyContains) {
            if (dom.isLeftEdgePoint(point)) {
              leftEdgeNodes.push(point.node);
            }
            if (dom.isRightEdgePoint(point) && list.contains(leftEdgeNodes, point.node)) {
              node = point.node;
            }
          } else if (includeAncestor) {
            node = dom.ancestor(point.node, pred);
          } else {
            node = point.node;
          }

          if (node && pred(node)) {
            nodes.push(node);
          }
        }, true);

        return list.unique(nodes);
      };

      /**
       * returns commonAncestor of range
       * @return {Element} - commonAncestor
       */
      this.commonAncestor = function () {
        return dom.commonAncestor(sc, ec);
      };

      /**
       * returns expanded range by pred
       *
       * @param {Function} pred - predicate function
       * @return {WrappedRange}
       */
      this.expand = function (pred) {
        var startAncestor = dom.ancestor(sc, pred);
        var endAncestor = dom.ancestor(ec, pred);

        if (!startAncestor && !endAncestor) {
          return new WrappedRange(sc, so, ec, eo);
        }

        var boundaryPoints = this.getPoints();

        if (startAncestor) {
          boundaryPoints.sc = startAncestor;
          boundaryPoints.so = 0;
        }

        if (endAncestor) {
          boundaryPoints.ec = endAncestor;
          boundaryPoints.eo = dom.nodeLength(endAncestor);
        }

        return new WrappedRange(
          boundaryPoints.sc,
          boundaryPoints.so,
          boundaryPoints.ec,
          boundaryPoints.eo
        );
      };

      /**
       * @param {Boolean} isCollapseToStart
       * @return {WrappedRange}
       */
      this.collapse = function (isCollapseToStart) {
        if (isCollapseToStart) {
          return new WrappedRange(sc, so, sc, so);
        } else {
          return new WrappedRange(ec, eo, ec, eo);
        }
      };

      /**
       * splitText on range
       */
      this.splitText = function () {
        var isSameContainer = sc === ec;
        var boundaryPoints = this.getPoints();

        if (dom.isText(ec) && !dom.isEdgePoint(this.getEndPoint())) {
          ec.splitText(eo);
        }

        if (dom.isText(sc) && !dom.isEdgePoint(this.getStartPoint())) {
          boundaryPoints.sc = sc.splitText(so);
          boundaryPoints.so = 0;

          if (isSameContainer) {
            boundaryPoints.ec = boundaryPoints.sc;
            boundaryPoints.eo = eo - so;
          }
        }

        return new WrappedRange(
          boundaryPoints.sc,
          boundaryPoints.so,
          boundaryPoints.ec,
          boundaryPoints.eo
        );
      };

      /**
       * delete contents on range
       * @return {WrappedRange}
       */
      this.deleteContents = function () {
        if (this.isCollapsed()) {
          return this;
        }

        var rng = this.splitText();
        var nodes = rng.nodes(null, {
          fullyContains: true
        });

        // find new cursor point
        var point = dom.prevPointUntil(rng.getStartPoint(), function (point) {
          return !list.contains(nodes, point.node);
        });

        var emptyParents = [];
        $.each(nodes, function (idx, node) {
          // find empty parents
          var parent = node.parentNode;
          if (point.node !== parent && dom.nodeLength(parent) === 1) {
            emptyParents.push(parent);
          }
          dom.remove(node, false);
        });

        // remove empty parents
        $.each(emptyParents, function (idx, node) {
          dom.remove(node, false);
        });

        return new WrappedRange(
          point.node,
          point.offset,
          point.node,
          point.offset
        ).normalize();
      };

      /**
       * makeIsOn: return isOn(pred) function
       */
      var makeIsOn = function (pred) {
        return function () {
          var ancestor = dom.ancestor(sc, pred);
          return !!ancestor && (ancestor === dom.ancestor(ec, pred));
        };
      };

      // isOnEditable: judge whether range is on editable or not
      this.isOnEditable = makeIsOn(dom.isEditable);
      // isOnList: judge whether range is on list node or not
      this.isOnList = makeIsOn(dom.isList);
      // isOnAnchor: judge whether range is on anchor node or not
      this.isOnAnchor = makeIsOn(dom.isAnchor);
      // isOnCell: judge whether range is on cell node or not
      this.isOnCell = makeIsOn(dom.isCell);
      // isOnData: judge whether range is on data node or not
      this.isOnData = makeIsOn(dom.isData);

      /**
       * @param {Function} pred
       * @return {Boolean}
       */
      this.isLeftEdgeOf = function (pred) {
        if (!dom.isLeftEdgePoint(this.getStartPoint())) {
          return false;
        }

        var node = dom.ancestor(this.sc, pred);
        return node && dom.isLeftEdgeOf(this.sc, node);
      };

      /**
       * returns whether range was collapsed or not
       */
      this.isCollapsed = function () {
        return sc === ec && so === eo;
      };

      /**
       * wrap inline nodes which children of body with paragraph
       *
       * @return {WrappedRange}
       */
      this.wrapBodyInlineWithPara = function () {
        if (dom.isBodyContainer(sc) && dom.isEmpty(sc)) {
          sc.innerHTML = dom.emptyPara;
          return new WrappedRange(sc.firstChild, 0, sc.firstChild, 0);
        }

        /**
         * [workaround] firefox often create range on not visible point. so normalize here.
         *  - firefox: |<p>text</p>|
         *  - chrome: <p>|text|</p>
         */
        var rng = this.normalize();
        if (dom.isParaInline(sc) || dom.isPara(sc)) {
          return rng;
        }

        // find inline top ancestor
        var topAncestor;
        if (dom.isInline(rng.sc)) {
          var ancestors = dom.listAncestor(rng.sc, func.not(dom.isInline));
          topAncestor = list.last(ancestors);
          if (!dom.isInline(topAncestor)) {
            topAncestor = ancestors[ancestors.length - 2] || rng.sc.childNodes[rng.so];
          }
        } else {
          topAncestor = rng.sc.childNodes[rng.so > 0 ? rng.so - 1 : 0];
        }

        // siblings not in paragraph
        var inlineSiblings = dom.listPrev(topAncestor, dom.isParaInline).reverse();
        inlineSiblings = inlineSiblings.concat(dom.listNext(topAncestor.nextSibling, dom.isParaInline));

        // wrap with paragraph
        if (inlineSiblings.length) {
          var para = dom.wrap(list.head(inlineSiblings), 'p');
          dom.appendChildNodes(para, list.tail(inlineSiblings));
        }

        return this.normalize();
      };

      /**
       * insert node at current cursor
       *
       * @param {Node} node
       * @return {Node}
       */
      this.insertNode = function (node) {
        var rng = this.wrapBodyInlineWithPara().deleteContents();
        var info = dom.splitPoint(rng.getStartPoint(), dom.isInline(node));

        if (info.rightNode) {
          info.rightNode.parentNode.insertBefore(node, info.rightNode);
        } else {
          info.container.appendChild(node);
        }

        return node;
      };

      /**
       * insert html at current cursor
       */
      this.pasteHTML = function (markup) {
        var contentsContainer = $('<div></div>').html(markup)[0];
        var childNodes = list.from(contentsContainer.childNodes);

        var rng = this.wrapBodyInlineWithPara().deleteContents();

        return childNodes.reverse().map(function (childNode) {
          return rng.insertNode(childNode);
        }).reverse();
      };

      /**
       * returns text in range
       *
       * @return {String}
       */
      this.toString = function () {
        var nativeRng = nativeRange();
        return agent.isW3CRangeSupport ? nativeRng.toString() : nativeRng.text;
      };

      /**
       * returns range for word before cursor
       *
       * @param {Boolean} [findAfter] - find after cursor, default: false
       * @return {WrappedRange}
       */
      this.getWordRange = function (findAfter) {
        var endPoint = this.getEndPoint();

        if (!dom.isCharPoint(endPoint)) {
          return this;
        }

        var startPoint = dom.prevPointUntil(endPoint, function (point) {
          return !dom.isCharPoint(point);
        });

        if (findAfter) {
          endPoint = dom.nextPointUntil(endPoint, function (point) {
            return !dom.isCharPoint(point);
          });
        }

        return new WrappedRange(
          startPoint.node,
          startPoint.offset,
          endPoint.node,
          endPoint.offset
        );
      };

      /**
       * create offsetPath bookmark
       *
       * @param {Node} editable
       */
      this.bookmark = function (editable) {
        return {
          s: {
            path: dom.makeOffsetPath(editable, sc),
            offset: so
          },
          e: {
            path: dom.makeOffsetPath(editable, ec),
            offset: eo
          }
        };
      };

      /**
       * create offsetPath bookmark base on paragraph
       *
       * @param {Node[]} paras
       */
      this.paraBookmark = function (paras) {
        return {
          s: {
            path: list.tail(dom.makeOffsetPath(list.head(paras), sc)),
            offset: so
          },
          e: {
            path: list.tail(dom.makeOffsetPath(list.last(paras), ec)),
            offset: eo
          }
        };
      };

      /**
       * getClientRects
       * @return {Rect[]}
       */
      this.getClientRects = function () {
        var nativeRng = nativeRange();
        return nativeRng.getClientRects();
      };
    };

  /**
   * @class core.range
   *
   * Data structure
   *  * BoundaryPoint: a point of dom tree
   *  * BoundaryPoints: two boundaryPoints corresponding to the start and the end of the Range
   *
   * See to http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Position
   *
   * @singleton
   * @alternateClassName range
   */
    return {
      /**
       * create Range Object From arguments or Browser Selection
       *
       * @param {Node} sc - start container
       * @param {Number} so - start offset
       * @param {Node} ec - end container
       * @param {Number} eo - end offset
       * @return {WrappedRange}
       */
      create: function (sc, so, ec, eo) {
        if (arguments.length === 4) {
          return new WrappedRange(sc, so, ec, eo);
        } else if (arguments.length === 2) { //collapsed
          ec = sc;
          eo = so;
          return new WrappedRange(sc, so, ec, eo);
        } else {
          var wrappedRange = this.createFromSelection();
          if (!wrappedRange && arguments.length === 1) {
            wrappedRange = this.createFromNode(arguments[0]);
            return wrappedRange.collapse(dom.emptyPara === arguments[0].innerHTML);
          }
          return wrappedRange;
        }
      },

      createFromSelection: function () {
        var sc, so, ec, eo;
        if (agent.isW3CRangeSupport) {
          var selection = document.getSelection();
          if (!selection || selection.rangeCount === 0) {
            return null;
          } else if (dom.isBody(selection.anchorNode)) {
            // Firefox: returns entire body as range on initialization.
            // We won't never need it.
            return null;
          }

          var nativeRng = selection.getRangeAt(0);
          sc = nativeRng.startContainer;
          so = nativeRng.startOffset;
          ec = nativeRng.endContainer;
          eo = nativeRng.endOffset;
        } else { // IE8: TextRange
          var textRange = document.selection.createRange();
          var textRangeEnd = textRange.duplicate();
          textRangeEnd.collapse(false);
          var textRangeStart = textRange;
          textRangeStart.collapse(true);

          var startPoint = textRangeToPoint(textRangeStart, true),
          endPoint = textRangeToPoint(textRangeEnd, false);

          // same visible point case: range was collapsed.
          if (dom.isText(startPoint.node) && dom.isLeftEdgePoint(startPoint) &&
              dom.isTextNode(endPoint.node) && dom.isRightEdgePoint(endPoint) &&
              endPoint.node.nextSibling === startPoint.node) {
            startPoint = endPoint;
          }

          sc = startPoint.cont;
          so = startPoint.offset;
          ec = endPoint.cont;
          eo = endPoint.offset;
        }

        return new WrappedRange(sc, so, ec, eo);
      },

      /**
       * @method
       *
       * create WrappedRange from node
       *
       * @param {Node} node
       * @return {WrappedRange}
       */
      createFromNode: function (node) {
        var sc = node;
        var so = 0;
        var ec = node;
        var eo = dom.nodeLength(ec);

        // browsers can't target a picture or void node
        if (dom.isVoid(sc)) {
          so = dom.listPrev(sc).length - 1;
          sc = sc.parentNode;
        }
        if (dom.isBR(ec)) {
          eo = dom.listPrev(ec).length - 1;
          ec = ec.parentNode;
        } else if (dom.isVoid(ec)) {
          eo = dom.listPrev(ec).length;
          ec = ec.parentNode;
        }

        return this.create(sc, so, ec, eo);
      },

      /**
       * create WrappedRange from node after position
       *
       * @param {Node} node
       * @return {WrappedRange}
       */
      createFromNodeBefore: function (node) {
        return this.createFromNode(node).collapse(true);
      },

      /**
       * create WrappedRange from node after position
       *
       * @param {Node} node
       * @return {WrappedRange}
       */
      createFromNodeAfter: function (node) {
        return this.createFromNode(node).collapse();
      },

      /**
       * @method
       *
       * create WrappedRange from bookmark
       *
       * @param {Node} editable
       * @param {Object} bookmark
       * @return {WrappedRange}
       */
      createFromBookmark: function (editable, bookmark) {
        var sc = dom.fromOffsetPath(editable, bookmark.s.path);
        var so = bookmark.s.offset;
        var ec = dom.fromOffsetPath(editable, bookmark.e.path);
        var eo = bookmark.e.offset;
        return new WrappedRange(sc, so, ec, eo);
      },

      /**
       * @method
       *
       * create WrappedRange from paraBookmark
       *
       * @param {Object} bookmark
       * @param {Node[]} paras
       * @return {WrappedRange}
       */
      createFromParaBookmark: function (bookmark, paras) {
        var so = bookmark.s.offset;
        var eo = bookmark.e.offset;
        var sc = dom.fromOffsetPath(list.head(paras), bookmark.s.path);
        var ec = dom.fromOffsetPath(list.last(paras), bookmark.e.path);

        return new WrappedRange(sc, so, ec, eo);
      }
    };
  })();

  /**
   * @class core.async
   *
   * Async functions which returns `Promise`
   *
   * @singleton
   * @alternateClassName async
   */
  var async = (function () {
    /**
     * @method readFileAsDataURL
     *
     * read contents of file as representing URL
     *
     * @param {File} file
     * @return {Promise} - then: dataUrl
     */
    var readFileAsDataURL = function (file) {
      return $.Deferred(function (deferred) {
        $.extend(new FileReader(), {
          onload: function (e) {
            var dataURL = e.target.result;
            deferred.resolve(dataURL);
          },
          onerror: function () {
            deferred.reject(this);
          }
        }).readAsDataURL(file);
      }).promise();
    };

    /**
     * @method createImage
     *
     * create `<image>` from url string
     *
     * @param {String} url
     * @return {Promise} - then: $image
     */
    var createImage = function (url) {
      return $.Deferred(function (deferred) {
        var $img = $('<img>');

        $img.one('load', function () {
          $img.off('error abort');
          deferred.resolve($img);
        }).one('error abort', function () {
          $img.off('load').detach();
          deferred.reject($img);
        }).css({
          display: 'none'
        }).appendTo(document.body).attr('src', url);
      }).promise();
    };

    return {
      readFileAsDataURL: readFileAsDataURL,
      createImage: createImage
    };
  })();

  /**
   * @class editing.History
   *
   * Editor History
   *
   */
  var History = function ($editable) {
    var stack = [], stackOffset = -1;
    var editable = $editable[0];

    var makeSnapshot = function () {
      var rng = range.create(editable);
      var emptyBookmark = {s: {path: [], offset: 0}, e: {path: [], offset: 0}};

      return {
        contents: $editable.html(),
        bookmark: (rng ? rng.bookmark(editable) : emptyBookmark)
      };
    };

    var applySnapshot = function (snapshot) {
      if (snapshot.contents !== null) {
        $editable.html(snapshot.contents);
      }
      if (snapshot.bookmark !== null) {
        range.createFromBookmark(editable, snapshot.bookmark).select();
      }
    };

    /**
    * @method rewind
    * Rewinds the history stack back to the first snapshot taken.
    * Leaves the stack intact, so that "Redo" can still be used.
    */
    this.rewind = function () {
      // Create snap shot if not yet recorded
      if ($editable.html() !== stack[stackOffset].contents) {
        this.recordUndo();
      }

      // Return to the first available snapshot.
      stackOffset = 0;

      // Apply that snapshot.
      applySnapshot(stack[stackOffset]);
    };

    /**
    * @method reset
    * Resets the history stack completely; reverting to an empty editor.
    */
    this.reset = function () {
      // Clear the stack.
      stack = [];

      // Restore stackOffset to its original value.
      stackOffset = -1;

      // Clear the editable area.
      $editable.html('');

      // Record our first snapshot (of nothing).
      this.recordUndo();
    };

    /**
     * undo
     */
    this.undo = function () {
      // Create snap shot if not yet recorded
      if ($editable.html() !== stack[stackOffset].contents) {
        this.recordUndo();
      }

      if (0 < stackOffset) {
        stackOffset--;
        applySnapshot(stack[stackOffset]);
      }
    };

    /**
     * redo
     */
    this.redo = function () {
      if (stack.length - 1 > stackOffset) {
        stackOffset++;
        applySnapshot(stack[stackOffset]);
      }
    };

    /**
     * recorded undo
     */
    this.recordUndo = function () {
      stackOffset++;

      // Wash out stack after stackOffset
      if (stack.length > stackOffset) {
        stack = stack.slice(0, stackOffset);
      }

      // Create new snapshot and push it to the end
      stack.push(makeSnapshot());
    };
  };

  /**
   * @class editing.Style
   *
   * Style
   *
   */
  var Style = function () {
    /**
     * @method jQueryCSS
     *
     * [workaround] for old jQuery
     * passing an array of style properties to .css()
     * will result in an object of property-value pairs.
     * (compability with version < 1.9)
     *
     * @private
     * @param  {jQuery} $obj
     * @param  {Array} propertyNames - An array of one or more CSS properties.
     * @return {Object}
     */
    var jQueryCSS = function ($obj, propertyNames) {
      if (agent.jqueryVersion < 1.9) {
        var result = {};
        $.each(propertyNames, function (idx, propertyName) {
          result[propertyName] = $obj.css(propertyName);
        });
        return result;
      }
      return $obj.css.call($obj, propertyNames);
    };

    /**
     * returns style object from node
     *
     * @param {jQuery} $node
     * @return {Object}
     */
    this.fromNode = function ($node) {
      var properties = ['font-family', 'font-size', 'text-align', 'list-style-type', 'line-height'];
      var styleInfo = jQueryCSS($node, properties) || {};
      styleInfo['font-size'] = parseInt(styleInfo['font-size'], 10);
      return styleInfo;
    };

    /**
     * paragraph level style
     *
     * @param {WrappedRange} rng
     * @param {Object} styleInfo
     */
    this.stylePara = function (rng, styleInfo) {
      $.each(rng.nodes(dom.isPara, {
        includeAncestor: true
      }), function (idx, para) {
        $(para).css(styleInfo);
      });
    };

    /**
     * insert and returns styleNodes on range.
     *
     * @param {WrappedRange} rng
     * @param {Object} [options] - options for styleNodes
     * @param {String} [options.nodeName] - default: `SPAN`
     * @param {Boolean} [options.expandClosestSibling] - default: `false`
     * @param {Boolean} [options.onlyPartialContains] - default: `false`
     * @return {Node[]}
     */
    this.styleNodes = function (rng, options) {
      rng = rng.splitText();

      var nodeName = options && options.nodeName || 'SPAN';
      var expandClosestSibling = !!(options && options.expandClosestSibling);
      var onlyPartialContains = !!(options && options.onlyPartialContains);

      if (rng.isCollapsed()) {
        return [rng.insertNode(dom.create(nodeName))];
      }

      var pred = dom.makePredByNodeName(nodeName);
      var nodes = rng.nodes(dom.isText, {
        fullyContains: true
      }).map(function (text) {
        return dom.singleChildAncestor(text, pred) || dom.wrap(text, nodeName);
      });

      if (expandClosestSibling) {
        if (onlyPartialContains) {
          var nodesInRange = rng.nodes();
          // compose with partial contains predication
          pred = func.and(pred, function (node) {
            return list.contains(nodesInRange, node);
          });
        }

        return nodes.map(function (node) {
          var siblings = dom.withClosestSiblings(node, pred);
          var head = list.head(siblings);
          var tails = list.tail(siblings);
          $.each(tails, function (idx, elem) {
            dom.appendChildNodes(head, elem.childNodes);
            dom.remove(elem);
          });
          return list.head(siblings);
        });
      } else {
        return nodes;
      }
    };

    /**
     * get current style on cursor
     *
     * @param {WrappedRange} rng
     * @return {Object} - object contains style properties.
     */
    this.current = function (rng) {
      var $cont = $(!dom.isElement(rng.sc) ? rng.sc.parentNode : rng.sc);
      var styleInfo = this.fromNode($cont);

      // document.queryCommandState for toggle state
      // [workaround] prevent Firefox nsresult: "0x80004005 (NS_ERROR_FAILURE)"
      try {
        styleInfo = $.extend(styleInfo, {
          'font-bold': document.queryCommandState('bold') ? 'bold' : 'normal',
          'font-italic': document.queryCommandState('italic') ? 'italic' : 'normal',
          'font-underline': document.queryCommandState('underline') ? 'underline' : 'normal',
          'font-subscript': document.queryCommandState('subscript') ? 'subscript' : 'normal',
          'font-superscript': document.queryCommandState('superscript') ? 'superscript' : 'normal',
          'font-strikethrough': document.queryCommandState('strikethrough') ? 'strikethrough' : 'normal'
        });
      } catch (e) {}

      // list-style-type to list-style(unordered, ordered)
      if (!rng.isOnList()) {
        styleInfo['list-style'] = 'none';
      } else {
        var orderedTypes = ['circle', 'disc', 'disc-leading-zero', 'square'];
        var isUnordered = $.inArray(styleInfo['list-style-type'], orderedTypes) > -1;
        styleInfo['list-style'] = isUnordered ? 'unordered' : 'ordered';
      }

      var para = dom.ancestor(rng.sc, dom.isPara);
      if (para && para.style['line-height']) {
        styleInfo['line-height'] = para.style.lineHeight;
      } else {
        var lineHeight = parseInt(styleInfo['line-height'], 10) / parseInt(styleInfo['font-size'], 10);
        styleInfo['line-height'] = lineHeight.toFixed(1);
      }

      styleInfo.anchor = rng.isOnAnchor() && dom.ancestor(rng.sc, dom.isAnchor);
      styleInfo.ancestors = dom.listAncestor(rng.sc, dom.isEditable);
      styleInfo.range = rng;

      return styleInfo;
    };
  };


  /**
   * @class editing.Bullet
   *
   * @alternateClassName Bullet
   */
  var Bullet = function () {
    var self = this;

    /**
     * toggle ordered list
     */
    this.insertOrderedList = function (editable) {
      this.toggleList('OL', editable);
    };

    /**
     * toggle unordered list
     */
    this.insertUnorderedList = function (editable) {
      this.toggleList('UL', editable);
    };

    /**
     * indent
     */
    this.indent = function (editable) {
      var self = this;
      var rng = range.create(editable).wrapBodyInlineWithPara();

      var paras = rng.nodes(dom.isPara, { includeAncestor: true });
      var clustereds = list.clusterBy(paras, func.peq2('parentNode'));

      $.each(clustereds, function (idx, paras) {
        var head = list.head(paras);
        if (dom.isLi(head)) {
          self.wrapList(paras, head.parentNode.nodeName);
        } else {
          $.each(paras, function (idx, para) {
            $(para).css('marginLeft', function (idx, val) {
              return (parseInt(val, 10) || 0) + 25;
            });
          });
        }
      });

      rng.select();
    };

    /**
     * outdent
     */
    this.outdent = function (editable) {
      var self = this;
      var rng = range.create(editable).wrapBodyInlineWithPara();

      var paras = rng.nodes(dom.isPara, { includeAncestor: true });
      var clustereds = list.clusterBy(paras, func.peq2('parentNode'));

      $.each(clustereds, function (idx, paras) {
        var head = list.head(paras);
        if (dom.isLi(head)) {
          self.releaseList([paras]);
        } else {
          $.each(paras, function (idx, para) {
            $(para).css('marginLeft', function (idx, val) {
              val = (parseInt(val, 10) || 0);
              return val > 25 ? val - 25 : '';
            });
          });
        }
      });

      rng.select();
    };

    /**
     * toggle list
     *
     * @param {String} listName - OL or UL
     */
    this.toggleList = function (listName, editable) {
      var rng = range.create(editable).wrapBodyInlineWithPara();

      var paras = rng.nodes(dom.isPara, { includeAncestor: true });
      var bookmark = rng.paraBookmark(paras);
      var clustereds = list.clusterBy(paras, func.peq2('parentNode'));

      // paragraph to list
      if (list.find(paras, dom.isPurePara)) {
        var wrappedParas = [];
        $.each(clustereds, function (idx, paras) {
          wrappedParas = wrappedParas.concat(self.wrapList(paras, listName));
        });
        paras = wrappedParas;
      // list to paragraph or change list style
      } else {
        var diffLists = rng.nodes(dom.isList, {
          includeAncestor: true
        }).filter(function (listNode) {
          return !$.nodeName(listNode, listName);
        });

        if (diffLists.length) {
          $.each(diffLists, function (idx, listNode) {
            dom.replace(listNode, listName);
          });
        } else {
          paras = this.releaseList(clustereds, true);
        }
      }

      range.createFromParaBookmark(bookmark, paras).select();
    };

    /**
     * @param {Node[]} paras
     * @param {String} listName
     * @return {Node[]}
     */
    this.wrapList = function (paras, listName) {
      var head = list.head(paras);
      var last = list.last(paras);

      var prevList = dom.isList(head.previousSibling) && head.previousSibling;
      var nextList = dom.isList(last.nextSibling) && last.nextSibling;

      var listNode = prevList || dom.insertAfter(dom.create(listName || 'UL'), last);

      // P to LI
      paras = paras.map(function (para) {
        return dom.isPurePara(para) ? dom.replace(para, 'LI') : para;
      });

      // append to list(<ul>, <ol>)
      dom.appendChildNodes(listNode, paras);

      if (nextList) {
        dom.appendChildNodes(listNode, list.from(nextList.childNodes));
        dom.remove(nextList);
      }

      return paras;
    };

    /**
     * @method releaseList
     *
     * @param {Array[]} clustereds
     * @param {Boolean} isEscapseToBody
     * @return {Node[]}
     */
    this.releaseList = function (clustereds, isEscapseToBody) {
      var releasedParas = [];

      $.each(clustereds, function (idx, paras) {
        var head = list.head(paras);
        var last = list.last(paras);

        var headList = isEscapseToBody ? dom.lastAncestor(head, dom.isList) :
                                         head.parentNode;
        var lastList = headList.childNodes.length > 1 ? dom.splitTree(headList, {
          node: last.parentNode,
          offset: dom.position(last) + 1
        }, {
          isSkipPaddingBlankHTML: true
        }) : null;

        var middleList = dom.splitTree(headList, {
          node: head.parentNode,
          offset: dom.position(head)
        }, {
          isSkipPaddingBlankHTML: true
        });

        paras = isEscapseToBody ? dom.listDescendant(middleList, dom.isLi) :
                                  list.from(middleList.childNodes).filter(dom.isLi);

        // LI to P
        if (isEscapseToBody || !dom.isList(headList.parentNode)) {
          paras = paras.map(function (para) {
            return dom.replace(para, 'P');
          });
        }

        $.each(list.from(paras).reverse(), function (idx, para) {
          dom.insertAfter(para, headList);
        });

        // remove empty lists
        var rootLists = list.compact([headList, middleList, lastList]);
        $.each(rootLists, function (idx, rootList) {
          var listNodes = [rootList].concat(dom.listDescendant(rootList, dom.isList));
          $.each(listNodes.reverse(), function (idx, listNode) {
            if (!dom.nodeLength(listNode)) {
              dom.remove(listNode, true);
            }
          });
        });

        releasedParas = releasedParas.concat(paras);
      });

      return releasedParas;
    };
  };


  /**
   * @class editing.Typing
   *
   * Typing
   *
   */
  var Typing = function () {

    // a Bullet instance to toggle lists off
    var bullet = new Bullet();

    /**
     * insert tab
     *
     * @param {WrappedRange} rng
     * @param {Number} tabsize
     */
    this.insertTab = function (rng, tabsize) {
      var tab = dom.createText(new Array(tabsize + 1).join(dom.NBSP_CHAR));
      rng = rng.deleteContents();
      rng.insertNode(tab, true);

      rng = range.create(tab, tabsize);
      rng.select();
    };

    /**
     * insert paragraph
     */
    this.insertParagraph = function (editable) {
      var rng = range.create(editable);

      // deleteContents on range.
      rng = rng.deleteContents();

      // Wrap range if it needs to be wrapped by paragraph
      rng = rng.wrapBodyInlineWithPara();

      // finding paragraph
      var splitRoot = dom.ancestor(rng.sc, dom.isPara);

      var nextPara;
      // on paragraph: split paragraph
      if (splitRoot) {
        // if it is an empty line with li
        if (dom.isEmpty(splitRoot) && dom.isLi(splitRoot)) {
          // toogle UL/OL and escape
          bullet.toggleList(splitRoot.parentNode.nodeName);
          return;
        // if it is an empty line with para on blockquote
        } else if (dom.isEmpty(splitRoot) && dom.isPara(splitRoot) && dom.isBlockquote(splitRoot.parentNode)) {
          // escape blockquote
          dom.insertAfter(splitRoot, splitRoot.parentNode);
          nextPara = splitRoot;
        // if new line has content (not a line break)
        } else {
          nextPara = dom.splitTree(splitRoot, rng.getStartPoint());

          var emptyAnchors = dom.listDescendant(splitRoot, dom.isEmptyAnchor);
          emptyAnchors = emptyAnchors.concat(dom.listDescendant(nextPara, dom.isEmptyAnchor));

          $.each(emptyAnchors, function (idx, anchor) {
            dom.remove(anchor);
          });

          // replace empty heading or pre with P tag
          if ((dom.isHeading(nextPara) || dom.isPre(nextPara)) && dom.isEmpty(nextPara)) {
            nextPara = dom.replace(nextPara, 'p');
          }
        }
      // no paragraph: insert empty paragraph
      } else {
        var next = rng.sc.childNodes[rng.so];
        nextPara = $(dom.emptyPara)[0];
        if (next) {
          rng.sc.insertBefore(nextPara, next);
        } else {
          rng.sc.appendChild(nextPara);
        }
      }

      range.create(nextPara, 0).normalize().select().scrollIntoView(editable);
    };
  };

  /**
   * @class editing.Table
   *
   * Table
   *
   */
  var Table = function () {
    /**
     * handle tab key
     *
     * @param {WrappedRange} rng
     * @param {Boolean} isShift
     */
    this.tab = function (rng, isShift) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var table = dom.ancestor(cell, dom.isTable);
      var cells = dom.listDescendant(table, dom.isCell);

      var nextCell = list[isShift ? 'prev' : 'next'](cells, cell);
      if (nextCell) {
        range.create(nextCell, 0).select();
      }
    };

    /**
     * create empty table element
     *
     * @param {Number} rowCount
     * @param {Number} colCount
     * @return {Node}
     */
    this.createTable = function (colCount, rowCount, options) {
      var tds = [], tdHTML;
      for (var idxCol = 0; idxCol < colCount; idxCol++) {
        tds.push('<td>' + dom.blank + '</td>');
      }
      tdHTML = tds.join('');

      var trs = [], trHTML;
      for (var idxRow = 0; idxRow < rowCount; idxRow++) {
        trs.push('<tr>' + tdHTML + '</tr>');
      }
      trHTML = trs.join('');
      var $table = $('<table>' + trHTML + '</table>');
      if (options && options.tableClassName) {
        $table.addClass(options.tableClassName);
      }

      return $table[0];
    };
  };


  var KEY_BOGUS = 'bogus';

  /**
   * @class Editor
   */
  var Editor = function (context) {
    var self = this;

    var $note = context.layoutInfo.note;
    var $editor = context.layoutInfo.editor;
    var $editable = context.layoutInfo.editable;
    var options = context.options;
    var lang = options.langInfo;

    var editable = $editable[0];
    var lastRange = null;

    var style = new Style();
    var table = new Table();
    var typing = new Typing();
    var bullet = new Bullet();
    var history = new History($editable);

    this.initialize = function () {
      // bind custom events
      $editable.on('keydown', function (event) {
        if (event.keyCode === key.code.ENTER) {
          context.triggerEvent('enter', event);
        }
        context.triggerEvent('keydown', event);

        if (!event.isDefaultPrevented()) {
          if (options.shortcuts) {
            self.handleKeyMap(event);
          } else {
            self.preventDefaultEditableShortCuts(event);
          }
        }
      }).on('keyup', function (event) {
        context.triggerEvent('keyup', event);
      }).on('focus', function (event) {
        context.triggerEvent('focus', event);
      }).on('blur', function (event) {
        context.triggerEvent('blur', event);
      }).on('mousedown', function (event) {
        context.triggerEvent('mousedown', event);
      }).on('mouseup', function (event) {
        context.triggerEvent('mouseup', event);
      }).on('scroll', function (event) {
        context.triggerEvent('scroll', event);
      }).on('paste', function (event) {
        context.triggerEvent('paste', event);
      });

      // init content before set event
      $editable.html(dom.html($note) || dom.emptyPara);

      // [workaround] IE doesn't have input events for contentEditable
      // - see: https://goo.gl/4bfIvA
      var changeEventName = agent.isMSIE ? 'DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted' : 'input';
      $editable.on(changeEventName, func.debounce(function () {
        context.triggerEvent('change', $editable.html());
      }, 250));

      $editor.on('focusin', function (event) {
        context.triggerEvent('focusin', event);
      }).on('focusout', function (event) {
        context.triggerEvent('focusout', event);
      });

      if (!options.airMode) {
        if (options.width) {
          $editor.outerWidth(options.width);
        }
        if (options.height) {
          $editable.outerHeight(options.height);
        }
        if (options.maxHeight) {
          $editable.css('max-height', options.maxHeight);
        }
        if (options.minHeight) {
          $editable.css('min-height', options.minHeight);
        }
      }

      history.recordUndo();
    };

    this.destroy = function () {
      $editable.off();
    };

    this.handleKeyMap = function (event) {
      var keyMap = options.keyMap[agent.isMac ? 'mac' : 'pc'];
      var keys = [];

      if (event.metaKey) { keys.push('CMD'); }
      if (event.ctrlKey && !event.altKey) { keys.push('CTRL'); }
      if (event.shiftKey) { keys.push('SHIFT'); }

      var keyName = key.nameFromCode[event.keyCode];
      if (keyName) {
        keys.push(keyName);
      }

      var eventName = keyMap[keys.join('+')];
      if (eventName) {
        event.preventDefault();
        context.invoke(eventName);
      } else if (key.isEdit(event.keyCode)) {
        this.afterCommand();
      }
    };

    this.preventDefaultEditableShortCuts = function (event) {
      // B(Bold, 66) / I(Italic, 73) / U(Underline, 85)
      if ((event.ctrlKey || event.metaKey) &&
        list.contains([66, 73, 85], event.keyCode)) {
        event.preventDefault();
      }
    };

    /**
     * create range
     * @return {WrappedRange}
     */
    this.createRange = function () {
      this.focus();
      return range.create(editable);
    };

    /**
     * saveRange
     *
     * save current range
     *
     * @param {Boolean} [thenCollapse=false]
     */
    this.saveRange = function (thenCollapse) {
      lastRange = this.createRange();
      if (thenCollapse) {
        lastRange.collapse().select();
      }
    };

    /**
     * restoreRange
     *
     * restore lately range
     */
    this.restoreRange = function () {
      if (lastRange) {
        lastRange.select();
        this.focus();
      }
    };

    this.saveTarget = function (node) {
      $editable.data('target', node);
    };

    this.clearTarget = function () {
      $editable.removeData('target');
    };

    this.restoreTarget = function () {
      return $editable.data('target');
    };

    /**
     * currentStyle
     *
     * current style
     * @return {Object|Boolean} unfocus
     */
    this.currentStyle = function () {
      var rng = range.create();
      if (rng) {
        rng = rng.normalize();
      }
      return rng ? style.current(rng) : style.fromNode($editable);
    };

    /**
     * style from node
     *
     * @param {jQuery} $node
     * @return {Object}
     */
    this.styleFromNode = function ($node) {
      return style.fromNode($node);
    };

    /**
     * undo
     */
    this.undo = function () {
      context.triggerEvent('before.command', $editable.html());
      history.undo();
      context.triggerEvent('change', $editable.html());
    };
    context.memo('help.undo', lang.help.undo);

    /**
     * redo
     */
    this.redo = function () {
      context.triggerEvent('before.command', $editable.html());
      history.redo();
      context.triggerEvent('change', $editable.html());
    };
    context.memo('help.redo', lang.help.redo);

    /**
     * before command
     */
    var beforeCommand = this.beforeCommand = function () {
      context.triggerEvent('before.command', $editable.html());
      // keep focus on editable before command execution
      self.focus();
    };

    /**
     * after command
     * @param {Boolean} isPreventTrigger
     */
    var afterCommand = this.afterCommand = function (isPreventTrigger) {
      history.recordUndo();
      if (!isPreventTrigger) {
        context.triggerEvent('change', $editable.html());
      }
    };

    /* jshint ignore:start */
    // native commands(with execCommand), generate function for execCommand
    var commands = ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript',
                    'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
                    'formatBlock', 'removeFormat',
                    'backColor', 'foreColor', 'fontName'];

    for (var idx = 0, len = commands.length; idx < len; idx ++) {
      this[commands[idx]] = (function (sCmd) {
        return function (value) {
          beforeCommand();
          document.execCommand(sCmd, false, value);
          afterCommand(true);
        };
      })(commands[idx]);
      context.memo('help.' + commands[idx], lang.help[commands[idx]]);
    }
    /* jshint ignore:end */

    /**
     * handle tab key
     */
    this.tab = function () {
      var rng = this.createRange();
      if (rng.isCollapsed() && rng.isOnCell()) {
        table.tab(rng);
      } else {
        beforeCommand();
        typing.insertTab(rng, options.tabSize);
        afterCommand();
      }
    };
    context.memo('help.tab', lang.help.tab);

    /**
     * handle shift+tab key
     */
    this.untab = function () {
      var rng = this.createRange();
      if (rng.isCollapsed() && rng.isOnCell()) {
        table.tab(rng, true);
      }
    };
    context.memo('help.untab', lang.help.untab);

    /**
     * run given function between beforeCommand and afterCommand
     */
    this.wrapCommand = function (fn) {
      return function () {
        beforeCommand();
        fn.apply(self, arguments);
        afterCommand();
      };
    };

    /**
     * insert paragraph
     */
    this.insertParagraph = this.wrapCommand(function () {
      typing.insertParagraph(editable);
    });
    context.memo('help.insertParagraph', lang.help.insertParagraph);

    this.insertOrderedList = this.wrapCommand(function () {
      bullet.insertOrderedList(editable);
    });
    context.memo('help.insertOrderedList', lang.help.insertOrderedList);

    this.insertUnorderedList = this.wrapCommand(function () {
      bullet.insertUnorderedList(editable);
    });
    context.memo('help.insertUnorderedList', lang.help.insertUnorderedList);

    this.indent = this.wrapCommand(function () {
      bullet.indent(editable);
    });
    context.memo('help.indent', lang.help.indent);

    this.outdent = this.wrapCommand(function () {
      bullet.outdent(editable);
    });
    context.memo('help.outdent', lang.help.outdent);

    /**
     * insert image
     *
     * @param {String} src
     * @param {String|Function} param
     * @return {Promise}
     */
    this.insertImage = function (src, param) {
      return async.createImage(src, param).then(function ($image) {
        beforeCommand();

        if (typeof param === 'function') {
          param($image);
        } else {
          if (typeof param === 'string') {
            $image.attr('data-filename', param);
          }
          $image.css('width', Math.min($editable.width(), $image.width()));
        }

        $image.show();
        range.create(editable).insertNode($image[0]);
        range.createFromNodeAfter($image[0]).select();
        afterCommand();
      }).fail(function (e) {
        context.triggerEvent('image.upload.error', e);
      });
    };

    /**
     * insertImages
     * @param {File[]} files
     */
    this.insertImages = function (files) {
      $.each(files, function (idx, file) {
        var filename = file.name;
        if (options.maximumImageFileSize && options.maximumImageFileSize < file.size) {
          context.triggerEvent('image.upload.error', lang.image.maximumFileSizeError);
        } else {
          async.readFileAsDataURL(file).then(function (dataURL) {
            return self.insertImage(dataURL, filename);
          }).fail(function () {
            context.triggerEvent('image.upload.error');
          });
        }
      });
    };

    /**
     * insertImagesOrCallback
     * @param {File[]} files
     */
    this.insertImagesOrCallback = function (files) {
      var callbacks = options.callbacks;

      // If onImageUpload options setted
      if (callbacks.onImageUpload) {
        context.triggerEvent('image.upload', files);
      // else insert Image as dataURL
      } else {
        this.insertImages(files);
      }
    };

    /**
     * insertNode
     * insert node
     * @param {Node} node
     */
    this.insertNode = this.wrapCommand(function (node) {
      var rng = this.createRange();
      rng.insertNode(node);
      range.createFromNodeAfter(node).select();
    });

    /**
     * insert text
     * @param {String} text
     */
    this.insertText = this.wrapCommand(function (text) {
      var rng = this.createRange();
      var textNode = rng.insertNode(dom.createText(text));
      range.create(textNode, dom.nodeLength(textNode)).select();
    });

    /**
     * return selected plain text
     * @return {String} text
     */
    this.getSelectedText = function () {
      var rng = this.createRange();

      // if range on anchor, expand range with anchor
      if (rng.isOnAnchor()) {
        rng = range.createFromNode(dom.ancestor(rng.sc, dom.isAnchor));
      }

      return rng.toString();
    };

    /**
     * paste HTML
     * @param {String} markup
     */
    this.pasteHTML = this.wrapCommand(function (markup) {
      var contents = this.createRange().pasteHTML(markup);
      range.createFromNodeAfter(list.last(contents)).select();
    });

    /**
     * formatBlock
     *
     * @param {String} tagName
     */
    this.formatBlock = this.wrapCommand(function (tagName) {
      // [workaround] for MSIE, IE need `<`
      tagName = agent.isMSIE ? '<' + tagName + '>' : tagName;
      document.execCommand('FormatBlock', false, tagName);
    });

    this.formatPara = function () {
      this.formatBlock('P');
    };
    context.memo('help.formatPara', lang.help.formatPara);

    /* jshint ignore:start */
    for (var idx = 1; idx <= 6; idx ++) {
      this['formatH' + idx] = function (idx) {
        return function () {
          this.formatBlock('H' + idx);
        };
      }(idx);
      context.memo('help.formatH'+idx, lang.help['formatH' + idx]);
    };
    /* jshint ignore:end */

    /**
     * fontSize
     *
     * @param {String} value - px
     */
    this.fontSize = function (value) {
      var rng = this.createRange();

      if (rng && rng.isCollapsed()) {
        var spans = style.styleNodes(rng);
        var firstSpan = list.head(spans);

        $(spans).css({
          'font-size': value + 'px'
        });

        // [workaround] added styled bogus span for style
        //  - also bogus character needed for cursor position
        if (firstSpan && !dom.nodeLength(firstSpan)) {
          firstSpan.innerHTML = dom.ZERO_WIDTH_NBSP_CHAR;
          range.createFromNodeAfter(firstSpan.firstChild).select();
          $editable.data(KEY_BOGUS, firstSpan);
        }
      } else {
        beforeCommand();
        $(style.styleNodes(rng)).css({
          'font-size': value + 'px'
        });
        afterCommand();
      }
    };

    /**
     * insert horizontal rule
     */
    this.insertHorizontalRule = this.wrapCommand(function () {
      var hrNode = this.createRange().insertNode(dom.create('HR'));
      if (hrNode.nextSibling) {
        range.create(hrNode.nextSibling, 0).normalize().select();
      }
    });
    context.memo('help.insertHorizontalRule', lang.help.insertHorizontalRule);

    /**
     * remove bogus node and character
     */
    this.removeBogus = function () {
      var bogusNode = $editable.data(KEY_BOGUS);
      if (!bogusNode) {
        return;
      }

      var textNode = list.find(list.from(bogusNode.childNodes), dom.isText);

      var bogusCharIdx = textNode.nodeValue.indexOf(dom.ZERO_WIDTH_NBSP_CHAR);
      if (bogusCharIdx !== -1) {
        textNode.deleteData(bogusCharIdx, 1);
      }

      if (dom.isEmpty(bogusNode)) {
        dom.remove(bogusNode);
      }

      $editable.removeData(KEY_BOGUS);
    };

    /**
     * lineHeight
     * @param {String} value
     */
    this.lineHeight = this.wrapCommand(function (value) {
      style.stylePara(this.createRange(), {
        lineHeight: value
      });
    });

    /**
     * unlink
     *
     * @type command
     */
    this.unlink = function () {
      var rng = this.createRange();
      if (rng.isOnAnchor()) {
        var anchor = dom.ancestor(rng.sc, dom.isAnchor);
        rng = range.createFromNode(anchor);
        rng.select();

        beforeCommand();
        document.execCommand('unlink');
        afterCommand();
      }
    };

    /**
     * create link (command)
     *
     * @param {Object} linkInfo
     */
    this.createLink = this.wrapCommand(function (linkInfo) {
      var linkUrl = linkInfo.url;
      var linkText = linkInfo.text;
      var isNewWindow = linkInfo.isNewWindow;
      var rng = linkInfo.range || this.createRange();
      var isTextChanged = rng.toString() !== linkText;

      // handle spaced urls from input
      if (typeof linkUrl === 'string') {
        linkUrl = linkUrl.trim();
      }

      if (options.onCreateLink) {
        linkUrl = options.onCreateLink(linkUrl);
      }

      var anchors = [];
      if (isTextChanged) {
        rng = rng.deleteContents();
        var anchor = rng.insertNode($('<A>' + linkText + '</A>')[0]);
        anchors.push(anchor);
      } else {
        anchors = style.styleNodes(rng, {
          nodeName: 'A',
          expandClosestSibling: true,
          onlyPartialContains: true
        });
      }

      $.each(anchors, function (idx, anchor) {
        // if url doesn't match an URL schema, set http:// as default
        linkUrl = /^[A-Za-z][A-Za-z0-9+-.]*\:[\/\/]?/.test(linkUrl) ?
          linkUrl : 'http://' + linkUrl;

        $(anchor).attr('href', linkUrl);
        if (isNewWindow) {
          $(anchor).attr('target', '_blank');
        } else {
          $(anchor).removeAttr('target');
        }
      });

      var startRange = range.createFromNodeBefore(list.head(anchors));
      var startPoint = startRange.getStartPoint();
      var endRange = range.createFromNodeAfter(list.last(anchors));
      var endPoint = endRange.getEndPoint();

      range.create(
        startPoint.node,
        startPoint.offset,
        endPoint.node,
        endPoint.offset
      ).select();
    });

    /**
     * returns link info
     *
     * @return {Object}
     * @return {WrappedRange} return.range
     * @return {String} return.text
     * @return {Boolean} [return.isNewWindow=true]
     * @return {String} [return.url=""]
     */
    this.getLinkInfo = function () {
      var rng = this.createRange().expand(dom.isAnchor);

      // Get the first anchor on range(for edit).
      var $anchor = $(list.head(rng.nodes(dom.isAnchor)));

      return {
        range: rng,
        text: rng.toString(),
        isNewWindow: $anchor.length ? $anchor.attr('target') === '_blank' : false,
        url: $anchor.length ? $anchor.attr('href') : ''
      };
    };

    /**
     * setting color
     *
     * @param {Object} sObjColor  color code
     * @param {String} sObjColor.foreColor foreground color
     * @param {String} sObjColor.backColor background color
     */
    this.color = this.wrapCommand(function (colorInfo) {
      var foreColor = colorInfo.foreColor;
      var backColor = colorInfo.backColor;

      if (foreColor) { document.execCommand('foreColor', false, foreColor); }
      if (backColor) { document.execCommand('backColor', false, backColor); }
    });

    /**
     * insert Table
     *
     * @param {String} dimension of table (ex : "5x5")
     */
    this.insertTable = this.wrapCommand(function (dim) {
      var dimension = dim.split('x');

      var rng = this.createRange().deleteContents();
      rng.insertNode(table.createTable(dimension[0], dimension[1], options));
    });

    /**
     * float me
     *
     * @param {String} value
     */
    this.floatMe = this.wrapCommand(function (value) {
      var $target = $(this.restoreTarget());
      $target.css('float', value);
    });

    /**
     * resize overlay element
     * @param {String} value
     */
    this.resize = this.wrapCommand(function (value) {
      var $target = $(this.restoreTarget());
      $target.css({
        width: value * 100 + '%',
        height: ''
      });
    });

    /**
     * @param {Position} pos
     * @param {jQuery} $target - target element
     * @param {Boolean} [bKeepRatio] - keep ratio
     */
    this.resizeTo = function (pos, $target, bKeepRatio) {
      var imageSize;
      if (bKeepRatio) {
        var newRatio = pos.y / pos.x;
        var ratio = $target.data('ratio');
        imageSize = {
          width: ratio > newRatio ? pos.x : pos.y / ratio,
          height: ratio > newRatio ? pos.x * ratio : pos.y
        };
      } else {
        imageSize = {
          width: pos.x,
          height: pos.y
        };
      }

      $target.css(imageSize);
    };

    /**
     * remove media object
     */
    this.removeMedia = this.wrapCommand(function () {
      var $target = $(this.restoreTarget()).detach();
      context.triggerEvent('media.delete', $target, $editable);
    });

    /**
     * returns whether editable area has focus or not.
     */
    this.hasFocus = function () {
      return $editable.is(':focus');
    };

    /**
     * set focus
     */
    this.focus = function () {
      // [workaround] Screen will move when page is scolled in IE.
      //  - do focus when not focused
      if (!this.hasFocus()) {
        $editable.focus();
      }
    };

    /**
     * returns whether contents is empty or not.
     * @return {Boolean}
     */
    this.isEmpty = function () {
      return dom.isEmpty($editable[0]) || dom.emptyPara === $editable.html();
    };

    /**
     * Removes all contents and restores the editable instance to an _emptyPara_.
     */
    this.empty = function () {
      context.invoke('code', dom.emptyPara);
    };
  };

  var Clipboard = function (context) {
    var self = this;

    var $editable = context.layoutInfo.editable;

    this.events = {
      'summernote.keydown': function (we, e) {
        if (self.needKeydownHook()) {
          if ((e.ctrlKey || e.metaKey) && e.keyCode === key.code.V) {
            context.invoke('editor.saveRange');
            self.$paste.focus();

            setTimeout(function () {
              self.pasteByHook();
            }, 0);
          }
        }
      }
    };

    this.needKeydownHook = function () {
      return (agent.isMSIE && agent.browserVersion > 10) || agent.isFF;
    };

    this.initialize = function () {
      // [workaround] getting image from clipboard
      //  - IE11 and Firefox: CTRL+v hook
      //  - Webkit: event.clipboardData
      if (this.needKeydownHook()) {
        this.$paste = $('<div tabindex="-1" />').attr('contenteditable', true).css({
          position: 'absolute',
          left: -100000,
          opacity: 0
        });
        $editable.before(this.$paste);

        this.$paste.on('paste', function (event) {
          context.triggerEvent('paste', event);
        });
      } else {
        $editable.on('paste', this.pasteByEvent);
      }
    };

    this.destroy = function () {
      if (this.needKeydownHook()) {
        this.$paste.remove();
        this.$paste = null;
      }
    };

    this.pasteByHook = function () {
      var node = this.$paste[0].firstChild;

      if (dom.isImg(node)) {
        var dataURI = node.src;
        var decodedData = atob(dataURI.split(',')[1]);
        var array = new Uint8Array(decodedData.length);
        for (var i = 0; i < decodedData.length; i++) {
          array[i] = decodedData.charCodeAt(i);
        }

        var blob = new Blob([array], { type: 'image/png' });
        blob.name = 'clipboard.png';

        context.invoke('editor.restoreRange');
        context.invoke('editor.focus');
        context.invoke('editor.insertImagesOrCallback', [blob]);
      } else {
        var pasteContent = $('<div />').html(this.$paste.html()).html();
        context.invoke('editor.restoreRange');
        context.invoke('editor.focus');

        if (pasteContent) {
          context.invoke('editor.pasteHTML', pasteContent);
        }
      }

      this.$paste.empty();
    };

    /**
     * paste by clipboard event
     *
     * @param {Event} event
     */
    this.pasteByEvent = function (event) {
      var clipboardData = event.originalEvent.clipboardData;
      if (clipboardData && clipboardData.items && clipboardData.items.length) {
        var item = list.head(clipboardData.items);
        if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
          context.invoke('editor.insertImagesOrCallback', [item.getAsFile()]);
        }
        context.invoke('editor.afterCommand');
      }
    };
  };

  var Dropzone = function (context) {
    var $document = $(document);
    var $editor = context.layoutInfo.editor;
    var $editable = context.layoutInfo.editable;
    var options = context.options;
    var lang = options.langInfo;
    var documentEventHandlers = {};

    var $dropzone = $([
      '<div class="note-dropzone">',
      '  <div class="note-dropzone-message"/>',
      '</div>'
    ].join('')).prependTo($editor);

    var detachDocumentEvent = function () {
      Object.keys(documentEventHandlers).forEach(function (key) {
        $document.off(key.substr(2).toLowerCase(), documentEventHandlers[key]);
      });
      documentEventHandlers = {};
    };

    /**
     * attach Drag and Drop Events
     */
    this.initialize = function () {
      if (options.disableDragAndDrop) {
        // prevent default drop event
        documentEventHandlers.onDrop = function (e) {
          e.preventDefault();
        };
        $document.on('drop', documentEventHandlers.onDrop);
      } else {
        this.attachDragAndDropEvent();
      }
    };

    /**
     * attach Drag and Drop Events
     */
    this.attachDragAndDropEvent = function () {
      var collection = $(),
          $dropzoneMessage = $dropzone.find('.note-dropzone-message');

      documentEventHandlers.onDragenter = function (e) {
        var isCodeview = context.invoke('codeview.isActivated');
        var hasEditorSize = $editor.width() > 0 && $editor.height() > 0;
        if (!isCodeview && !collection.length && hasEditorSize) {
          $editor.addClass('dragover');
          $dropzone.width($editor.width());
          $dropzone.height($editor.height());
          $dropzoneMessage.text(lang.image.dragImageHere);
        }
        collection = collection.add(e.target);
      };

      documentEventHandlers.onDragleave = function (e) {
        collection = collection.not(e.target);
        if (!collection.length) {
          $editor.removeClass('dragover');
        }
      };

      documentEventHandlers.onDrop = function () {
        collection = $();
        $editor.removeClass('dragover');
      };

      // show dropzone on dragenter when dragging a object to document
      // -but only if the editor is visible, i.e. has a positive width and height
      $document.on('dragenter', documentEventHandlers.onDragenter)
        .on('dragleave', documentEventHandlers.onDragleave)
        .on('drop', documentEventHandlers.onDrop);

      // change dropzone's message on hover.
      $dropzone.on('dragenter', function () {
        $dropzone.addClass('hover');
        $dropzoneMessage.text(lang.image.dropImage);
      }).on('dragleave', function () {
        $dropzone.removeClass('hover');
        $dropzoneMessage.text(lang.image.dragImageHere);
      });

      // attach dropImage
      $dropzone.on('drop', function (event) {
        var dataTransfer = event.originalEvent.dataTransfer;

        if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
          event.preventDefault();
          $editable.focus();
          context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
        } else {
          $.each(dataTransfer.types, function (idx, type) {
            var content = dataTransfer.getData(type);

            if (type.toLowerCase().indexOf('text') > -1) {
              context.invoke('editor.pasteHTML', content);
            } else {
              $(content).each(function () {
                context.invoke('editor.insertNode', this);
              });
            }
          });
        }
      }).on('dragover', false); // prevent default dragover event
    };

    this.destroy = function () {
      detachDocumentEvent();
    };
  };


  var CodeMirror;
  if (agent.hasCodeMirror) {
    if (agent.isSupportAmd) {
      require(['codemirror'], function (cm) {
        CodeMirror = cm;
      });
    } else {
      CodeMirror = window.CodeMirror;
    }
  }

  /**
   * @class Codeview
   */
  var Codeview = function (context) {
    var $editor = context.layoutInfo.editor;
    var $editable = context.layoutInfo.editable;
    var $codable = context.layoutInfo.codable;
    var options = context.options;

    this.sync = function () {
      var isCodeview = this.isActivated();
      if (isCodeview && agent.hasCodeMirror) {
        $codable.data('cmEditor').save();
      }
    };

    /**
     * @return {Boolean}
     */
    this.isActivated = function () {
      return $editor.hasClass('codeview');
    };

    /**
     * toggle codeview
     */
    this.toggle = function () {
      if (this.isActivated()) {
        this.deactivate();
      } else {
        this.activate();
      }
      context.triggerEvent('codeview.toggled');
    };

    /**
     * activate code view
     */
    this.activate = function () {
      $codable.val(dom.html($editable, options.prettifyHtml));
      $codable.height($editable.height());

      context.invoke('toolbar.updateCodeview', true);
      $editor.addClass('codeview');
      $codable.focus();

      // activate CodeMirror as codable
      if (agent.hasCodeMirror) {
        var cmEditor = CodeMirror.fromTextArea($codable[0], options.codemirror);

        // CodeMirror TernServer
        if (options.codemirror.tern) {
          var server = new CodeMirror.TernServer(options.codemirror.tern);
          cmEditor.ternServer = server;
          cmEditor.on('cursorActivity', function (cm) {
            server.updateArgHints(cm);
          });
        }

        // CodeMirror hasn't Padding.
        cmEditor.setSize(null, $editable.outerHeight());
        $codable.data('cmEditor', cmEditor);
      }
    };

    /**
     * deactivate code view
     */
    this.deactivate = function () {
      // deactivate CodeMirror as codable
      if (agent.hasCodeMirror) {
        var cmEditor = $codable.data('cmEditor');
        $codable.val(cmEditor.getValue());
        cmEditor.toTextArea();
      }

      var value = dom.value($codable, options.prettifyHtml) || dom.emptyPara;
      var isChange = $editable.html() !== value;

      $editable.html(value);
      $editable.height(options.height ? $codable.height() : 'auto');
      $editor.removeClass('codeview');

      if (isChange) {
        context.triggerEvent('change', $editable.html(), $editable);
      }

      $editable.focus();

      context.invoke('toolbar.updateCodeview', false);
    };

    this.destroy = function () {
      if (this.isActivated()) {
        this.deactivate();
      }
    };
  };

  var EDITABLE_PADDING = 24;

  var Statusbar = function (context) {
    var $document = $(document);
    var $statusbar = context.layoutInfo.statusbar;
    var $editable = context.layoutInfo.editable;
    var options = context.options;

    this.initialize = function () {
      if (options.airMode || options.disableResizeEditor) {
        return;
      }

      $statusbar.on('mousedown', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var editableTop = $editable.offset().top - $document.scrollTop();

        $document.on('mousemove', function (event) {
          var height = event.clientY - (editableTop + EDITABLE_PADDING);

          height = (options.minheight > 0) ? Math.max(height, options.minheight) : height;
          height = (options.maxHeight > 0) ? Math.min(height, options.maxHeight) : height;

          $editable.height(height);
        }).one('mouseup', function () {
          $document.off('mousemove');
        });
      });
    };

    this.destroy = function () {
      $statusbar.off();
      $statusbar.remove();
    };
  };

  var Fullscreen = function (context) {
    var $editor = context.layoutInfo.editor;
    var $toolbar = context.layoutInfo.toolbar;
    var $editable = context.layoutInfo.editable;
    var $codable = context.layoutInfo.codable;

    var $window = $(window);
    var $scrollbar = $('html, body');

    /**
     * toggle fullscreen
     */
    this.toggle = function () {
      var resize = function (size) {
        $editable.css('height', size.h);
        $codable.css('height', size.h);
        if ($codable.data('cmeditor')) {
          $codable.data('cmeditor').setsize(null, size.h);
        }
      };

      $editor.toggleClass('fullscreen');
      if (this.isFullscreen()) {
        $editable.data('orgHeight', $editable.css('height'));

        $window.on('resize', function () {
          resize({
            h: $window.height() - $toolbar.outerHeight()
          });
        }).trigger('resize');

        $scrollbar.css('overflow', 'hidden');
      } else {
        $window.off('resize');
        resize({
          h: $editable.data('orgHeight')
        });
        $scrollbar.css('overflow', 'visible');
      }

      context.invoke('toolbar.updateFullscreen', this.isFullscreen());
    };

    this.isFullscreen = function () {
      return $editor.hasClass('fullscreen');
    };
  };

  var Handle = function (context) {
    var self = this;

    var $document = $(document);
    var $editingArea = context.layoutInfo.editingArea;
    var options = context.options;

    this.events = {
      'summernote.mousedown': function (we, e) {
        if (self.update(e.target)) {
          e.preventDefault();
        }
      },
      'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function () {
        self.update();
      }
    };

    this.initialize = function () {
      this.$handle = $([
        '<div class="note-handle">',
        '<div class="note-control-selection">',
        '<div class="note-control-selection-bg"></div>',
        '<div class="note-control-holder note-control-nw"></div>',
        '<div class="note-control-holder note-control-ne"></div>',
        '<div class="note-control-holder note-control-sw"></div>',
        '<div class="',
        (options.disableResizeImage ? 'note-control-holder' : 'note-control-sizing'),
        ' note-control-se"></div>',
        (options.disableResizeImage ? '' : '<div class="note-control-selection-info"></div>'),
        '</div>',
        '</div>'
      ].join('')).prependTo($editingArea);

      this.$handle.on('mousedown', function (event) {
        if (dom.isControlSizing(event.target)) {
          event.preventDefault();
          event.stopPropagation();

          var $target = self.$handle.find('.note-control-selection').data('target'),
              posStart = $target.offset(),
              scrollTop = $document.scrollTop();

          $document.on('mousemove', function (event) {
            context.invoke('editor.resizeTo', {
              x: event.clientX - posStart.left,
              y: event.clientY - (posStart.top - scrollTop)
            }, $target, !event.shiftKey);

            self.update($target[0]);
          }).one('mouseup', function (e) {
            e.preventDefault();
            $document.off('mousemove');
            context.invoke('editor.afterCommand');
          });

          if (!$target.data('ratio')) { // original ratio.
            $target.data('ratio', $target.height() / $target.width());
          }
        }
      });
    };

    this.destroy = function () {
      this.$handle.remove();
    };

    this.update = function (target) {
      var isImage = dom.isImg(target);
      var $selection = this.$handle.find('.note-control-selection');

      context.invoke('imagePopover.update', target);

      if (isImage) {
        var $image = $(target);
        var pos = $image.position();

        // include margin
        var imageSize = {
          w: $image.outerWidth(true),
          h: $image.outerHeight(true)
        };

        $selection.css({
          display: 'block',
          left: pos.left,
          top: pos.top,
          width: imageSize.w,
          height: imageSize.h
        }).data('target', $image); // save current image element.

        var sizingText = imageSize.w + 'x' + imageSize.h;
        $selection.find('.note-control-selection-info').text(sizingText);
        context.invoke('editor.saveTarget', target);
      } else {
        this.hide();
      }

      return isImage;
    };

    /**
     * hide
     *
     * @param {jQuery} $handle
     */
    this.hide = function () {
      context.invoke('editor.clearTarget');
      this.$handle.children().hide();
    };
  };

  var AutoLink = function (context) {
    var self = this;
    var defaultScheme = 'http://';
    var linkPattern = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/\/]?|mailto:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i;

    this.events = {
      'summernote.keyup': function (we, e) {
        if (!e.isDefaultPrevented()) {
          self.handleKeyup(e);
        }
      },
      'summernote.keydown': function (we, e) {
        self.handleKeydown(e);
      }
    };

    this.initialize = function () {
      this.lastWordRange = null;
    };

    this.destroy = function () {
      this.lastWordRange = null;
    };

    this.replace = function () {
      if (!this.lastWordRange) {
        return;
      }

      var keyword = this.lastWordRange.toString();
      var match = keyword.match(linkPattern);

      if (match && (match[1] || match[2])) {
        var link = match[1] ? keyword : defaultScheme + keyword;
        var node = $('<a />').html(keyword).attr('href', link)[0];

        this.lastWordRange.insertNode(node);
        this.lastWordRange = null;
        context.invoke('editor.focus');
      }

    };

    this.handleKeydown = function (e) {
      if (list.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
        var wordRange = context.invoke('editor.createRange').getWordRange();
        this.lastWordRange = wordRange;
      }
    };

    this.handleKeyup = function (e) {
      if (list.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
        this.replace();
      }
    };
  };

  /**
   * textarea auto sync.
   */
  var AutoSync = function (context) {
    var $note = context.layoutInfo.note;

    this.events = {
      'summernote.change': function () {
        $note.val(context.invoke('code'));
      }
    };

    this.shouldInitialize = function () {
      return dom.isTextarea($note[0]);
    };
  };

  var Placeholder = function (context) {
    var self = this;
    var $editingArea = context.layoutInfo.editingArea;
    var options = context.options;

    this.events = {
      'summernote.init summernote.change': function () {
        self.update();
      },
      'summernote.codeview.toggled': function () {
        self.update();
      }
    };

    this.shouldInitialize = function () {
      return !!options.placeholder;
    };

    this.initialize = function () {
      this.$placeholder = $('<div class="note-placeholder">');
      this.$placeholder.on('click', function () {
        context.invoke('focus');
      }).text(options.placeholder).prependTo($editingArea);
    };

    this.destroy = function () {
      this.$placeholder.remove();
    };

    this.update = function () {
      var isShow = !context.invoke('codeview.isActivated') && context.invoke('editor.isEmpty');
      this.$placeholder.toggle(isShow);
    };
  };

  var Buttons = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var $toolbar = context.layoutInfo.toolbar;
    var options = context.options;
    var lang = options.langInfo;

    var invertedKeyMap = func.invertObject(options.keyMap[agent.isMac ? 'mac' : 'pc']);

    var representShortcut = this.representShortcut = function (editorMethod) {
      var shortcut = invertedKeyMap[editorMethod];
      if (!options.shortcuts || !shortcut) {
        return '';
      }

      if (agent.isMac) {
        shortcut = shortcut.replace('CMD', '⌘').replace('SHIFT', '⇧');
      }

      shortcut = shortcut.replace('BACKSLASH', '\\')
                         .replace('SLASH', '/')
                         .replace('LEFTBRACKET', '[')
                         .replace('RIGHTBRACKET', ']');

      return ' (' + shortcut + ')';
    };

    this.initialize = function () {
      this.addToolbarButtons();
      this.addImagePopoverButtons();
      this.addLinkPopoverButtons();
      this.fontInstalledMap = {};
    };

    this.destroy = function () {
      delete this.fontInstalledMap;
    };

    this.isFontInstalled = function (name) {
      if (!self.fontInstalledMap.hasOwnProperty(name)) {
        self.fontInstalledMap[name] = agent.isFontInstalled(name) ||
          list.contains(options.fontNamesIgnoreCheck, name);
      }

      return self.fontInstalledMap[name];
    };

    this.addToolbarButtons = function () {
      context.memo('button.style', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: ui.icon(options.icons.magic) + ' ' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.style.style,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdown({
            className: 'dropdown-style',
            items: context.options.styleTags,
            template: function (item) {

              if (typeof item === 'string') {
                item = { tag: item, title: (lang.style.hasOwnProperty(item) ? lang.style[item] : item) };
              }

              var tag = item.tag;
              var title = item.title;
              var style = item.style ? ' style="' + item.style + '" ' : '';
              var className = item.className ? ' class="' + item.className + '"' : '';

              return '<' + tag + style + className + '>' + title + '</' + tag +  '>';
            },
            click: context.createInvokeHandler('editor.formatBlock')
          })
        ]).render();
      });

      context.memo('button.bold', function () {
        return ui.button({
          className: 'note-btn-bold',
          contents: ui.icon(options.icons.bold),
          tooltip: lang.font.bold + representShortcut('bold'),
          click: context.createInvokeHandler('editor.bold')
        }).render();
      });

      context.memo('button.italic', function () {
        return ui.button({
          className: 'note-btn-italic',
          contents: ui.icon(options.icons.italic),
          tooltip: lang.font.italic + representShortcut('italic'),
          click: context.createInvokeHandler('editor.italic')
        }).render();
      });

      context.memo('button.underline', function () {
        return ui.button({
          className: 'note-btn-underline',
          contents: ui.icon(options.icons.underline),
          tooltip: lang.font.underline + representShortcut('underline'),
          click: context.createInvokeHandler('editor.underline')
        }).render();
      });

      context.memo('button.clear', function () {
        return ui.button({
          contents: ui.icon(options.icons.eraser),
          tooltip: lang.font.clear + representShortcut('removeFormat'),
          click: context.createInvokeHandler('editor.removeFormat')
        }).render();
      });

      context.memo('button.strikethrough', function () {
        return ui.button({
          className: 'note-btn-strikethrough',
          contents: ui.icon(options.icons.strikethrough),
          tooltip: lang.font.strikethrough + representShortcut('strikethrough'),
          click: context.createInvokeHandler('editor.strikethrough')
        }).render();
      });

      context.memo('button.superscript', function () {
        return ui.button({
          className: 'note-btn-superscript',
          contents: ui.icon(options.icons.superscript),
          tooltip: lang.font.superscript,
          click: context.createInvokeHandler('editor.superscript')
        }).render();
      });

      context.memo('button.subscript', function () {
        return ui.button({
          className: 'note-btn-subscript',
          contents: ui.icon(options.icons.subscript),
          tooltip: lang.font.subscript,
          click: context.createInvokeHandler('editor.subscript')
        }).render();
      });

      context.memo('button.fontname', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: '<span class="note-current-fontname"/> ' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.font.name,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdownCheck({
            className: 'dropdown-fontname',
            checkClassName: options.icons.menuCheck,
            items: options.fontNames.filter(self.isFontInstalled),
            template: function (item) {
              return '<span style="font-family:' + item + '">' + item + '</span>';
            },
            click: context.createInvokeHandler('editor.fontName')
          })
        ]).render();
      });

      context.memo('button.fontsize', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: '<span class="note-current-fontsize"/>' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.font.size,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdownCheck({
            className: 'dropdown-fontsize',
            checkClassName: options.icons.menuCheck,
            items: options.fontSizes,
            click: context.createInvokeHandler('editor.fontSize')
          })
        ]).render();
      });

      context.memo('button.color', function () {
        return ui.buttonGroup({
          className: 'note-color',
          children: [
            ui.button({
              className: 'note-current-color-button',
              contents: ui.icon(options.icons.font + ' note-recent-color'),
              tooltip: lang.color.recent,
              click: function (e) {
                var $button = $(e.currentTarget);
                context.invoke('editor.color', {
                  backColor: $button.attr('data-backColor'),
                  foreColor: $button.attr('data-foreColor')
                });
              },
              callback: function ($button) {
                var $recentColor = $button.find('.note-recent-color');
                $recentColor.css('background-color', '#FFFF00');
                $button.attr('data-backColor', '#FFFF00');
              }
            }),
            ui.button({
              className: 'dropdown-toggle',
              contents: ui.icon(options.icons.caret, 'span'),
              tooltip: lang.color.more,
              data: {
                toggle: 'dropdown'
              }
            }),
            ui.dropdown({
              items: [
                '<li>',
                '<div class="btn-group">',
                '  <div class="note-palette-title">' + lang.color.background + '</div>',
                '  <div>',
                '    <button type="button" class="note-color-reset btn btn-default" data-event="backColor" data-value="inherit">',
                lang.color.transparent,
                '    </button>',
                '  </div>',
                '  <div class="note-holder" data-event="backColor"/>',
                '</div>',
                '<div class="btn-group">',
                '  <div class="note-palette-title">' + lang.color.foreground + '</div>',
                '  <div>',
                '    <button type="button" class="note-color-reset btn btn-default" data-event="removeFormat" data-value="foreColor">',
                lang.color.resetToDefault,
                '    </button>',
                '  </div>',
                '  <div class="note-holder" data-event="foreColor"/>',
                '</div>',
                '</li>'
              ].join(''),
              callback: function ($dropdown) {
                $dropdown.find('.note-holder').each(function () {
                  var $holder = $(this);
                  $holder.append(ui.palette({
                    colors: options.colors,
                    eventName: $holder.data('event')
                  }).render());
                });
              },
              click: function (event) {
                var $button = $(event.target);
                var eventName = $button.data('event');
                var value = $button.data('value');

                if (eventName && value) {
                  var key = eventName === 'backColor' ? 'background-color' : 'color';
                  var $color = $button.closest('.note-color').find('.note-recent-color');
                  var $currentButton = $button.closest('.note-color').find('.note-current-color-button');

                  $color.css(key, value);
                  $currentButton.attr('data-' + eventName, value);
                  context.invoke('editor.' + eventName, value);
                }
              }
            })
          ]
        }).render();
      });

      context.memo('button.ul',  function () {
        return ui.button({
          contents: ui.icon(options.icons.unorderedlist),
          tooltip: lang.lists.unordered + representShortcut('insertUnorderedList'),
          click: context.createInvokeHandler('editor.insertUnorderedList')
        }).render();
      });

      context.memo('button.ol', function () {
        return ui.button({
          contents: ui.icon(options.icons.orderedlist),
          tooltip: lang.lists.ordered + representShortcut('insertOrderedList'),
          click:  context.createInvokeHandler('editor.insertOrderedList')
        }).render();
      });

      var justifyLeft = ui.button({
        contents: ui.icon(options.icons.alignLeft),
        tooltip: lang.paragraph.left + representShortcut('justifyLeft'),
        click: context.createInvokeHandler('editor.justifyLeft')
      });

      var justifyCenter = ui.button({
        contents: ui.icon(options.icons.alignCenter),
        tooltip: lang.paragraph.center + representShortcut('justifyCenter'),
        click: context.createInvokeHandler('editor.justifyCenter')
      });

      var justifyRight = ui.button({
        contents: ui.icon(options.icons.alignRight),
        tooltip: lang.paragraph.right + representShortcut('justifyRight'),
        click: context.createInvokeHandler('editor.justifyRight')
      });

      var justifyFull = ui.button({
        contents: ui.icon(options.icons.alignJustify),
        tooltip: lang.paragraph.justify + representShortcut('justifyFull'),
        click: context.createInvokeHandler('editor.justifyFull')
      });

      var outdent = ui.button({
        contents: ui.icon(options.icons.outdent),
        tooltip: lang.paragraph.outdent + representShortcut('outdent'),
        click: context.createInvokeHandler('editor.outdent')
      });

      var indent = ui.button({
        contents: ui.icon(options.icons.indent),
        tooltip: lang.paragraph.indent + representShortcut('indent'),
        click: context.createInvokeHandler('editor.indent')
      });

      context.memo('button.justifyLeft', func.invoke(justifyLeft, 'render'));
      context.memo('button.justifyCenter', func.invoke(justifyCenter, 'render'));
      context.memo('button.justifyRight', func.invoke(justifyRight, 'render'));
      context.memo('button.justifyFull', func.invoke(justifyFull, 'render'));
      context.memo('button.outdent', func.invoke(outdent, 'render'));
      context.memo('button.indent', func.invoke(indent, 'render'));

      context.memo('button.paragraph', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: ui.icon(options.icons.alignLeft) + ' ' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.paragraph.paragraph,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdown([
            ui.buttonGroup({
              className: 'note-align',
              children: [justifyLeft, justifyCenter, justifyRight, justifyFull]
            }),
            ui.buttonGroup({
              className: 'note-list',
              children: [outdent, indent]
            })
          ])
        ]).render();
      });

      context.memo('button.height', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: ui.icon(options.icons.textHeight) + ' ' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.font.height,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdownCheck({
            items: options.lineHeights,
            checkClassName: options.icons.menuCheck,
            className: 'dropdown-line-height',
            click: context.createInvokeHandler('editor.lineHeight')
          })
        ]).render();
      });

      context.memo('button.table', function () {
        return ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle',
            contents: ui.icon(options.icons.table) + ' ' + ui.icon(options.icons.caret, 'span'),
            tooltip: lang.table.table,
            data: {
              toggle: 'dropdown'
            }
          }),
          ui.dropdown({
            className: 'note-table',
            items: [
              '<div class="note-dimension-picker">',
              '  <div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"/>',
              '  <div class="note-dimension-picker-highlighted"/>',
              '  <div class="note-dimension-picker-unhighlighted"/>',
              '</div>',
              '<div class="note-dimension-display">1 x 1</div>'
            ].join('')
          })
        ], {
          callback: function ($node) {
            var $catcher = $node.find('.note-dimension-picker-mousecatcher');
            $catcher.css({
              width: options.insertTableMaxSize.col + 'em',
              height: options.insertTableMaxSize.row + 'em'
            }).mousedown(context.createInvokeHandler('editor.insertTable'))
              .on('mousemove', self.tableMoveHandler);
          }
        }).render();
      });

      context.memo('button.link', function () {
        return ui.button({
          contents: ui.icon(options.icons.link),
          tooltip: lang.link.link + representShortcut('linkDialog.show'),
          click: context.createInvokeHandler('linkDialog.show')
        }).render();
      });

      context.memo('button.picture', function () {
        return ui.button({
          contents: ui.icon(options.icons.picture),
          tooltip: lang.image.image,
          click: context.createInvokeHandler('imageDialog.show')
        }).render();
      });

      context.memo('button.video', function () {
        return ui.button({
          contents: ui.icon(options.icons.video),
          tooltip: lang.video.video,
          click: context.createInvokeHandler('videoDialog.show')
        }).render();
      });

      context.memo('button.hr', function () {
        return ui.button({
          contents: ui.icon(options.icons.minus),
          tooltip: lang.hr.insert + representShortcut('insertHorizontalRule'),
          click: context.createInvokeHandler('editor.insertHorizontalRule')
        }).render();
      });

      context.memo('button.fullscreen', function () {
        return ui.button({
          className: 'btn-fullscreen',
          contents: ui.icon(options.icons.arrowsAlt),
          tooltip: lang.options.fullscreen,
          click: context.createInvokeHandler('fullscreen.toggle')
        }).render();
      });

      context.memo('button.codeview', function () {
        return ui.button({
          className: 'btn-codeview',
          contents: ui.icon(options.icons.code),
          tooltip: lang.options.codeview,
          click: context.createInvokeHandler('codeview.toggle')
        }).render();
      });

      context.memo('button.redo', function () {
        return ui.button({
          contents: ui.icon(options.icons.redo),
          tooltip: lang.history.redo + representShortcut('redo'),
          click: context.createInvokeHandler('editor.redo')
        }).render();
      });

      context.memo('button.undo', function () {
        return ui.button({
          contents: ui.icon(options.icons.undo),
          tooltip: lang.history.undo + representShortcut('undo'),
          click: context.createInvokeHandler('editor.undo')
        }).render();
      });

      context.memo('button.help', function () {
        return ui.button({
          contents: ui.icon(options.icons.question),
          tooltip: lang.options.help,
          click: context.createInvokeHandler('helpDialog.show')
        }).render();
      });
    };

    /**
     * image : [
     *   ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
     *   ['float', ['floatLeft', 'floatRight', 'floatNone' ]],
     *   ['remove', ['removeMedia']]
     * ],
     */
    this.addImagePopoverButtons = function () {
      // Image Size Buttons
      context.memo('button.imageSize100', function () {
        return ui.button({
          contents: '<span class="note-fontsize-10">100%</span>',
          tooltip: lang.image.resizeFull,
          click: context.createInvokeHandler('editor.resize', '1')
        }).render();
      });
      context.memo('button.imageSize50', function () {
        return  ui.button({
          contents: '<span class="note-fontsize-10">50%</span>',
          tooltip: lang.image.resizeHalf,
          click: context.createInvokeHandler('editor.resize', '0.5')
        }).render();
      });
      context.memo('button.imageSize25', function () {
        return ui.button({
          contents: '<span class="note-fontsize-10">25%</span>',
          tooltip: lang.image.resizeQuarter,
          click: context.createInvokeHandler('editor.resize', '0.25')
        }).render();
      });

      // Float Buttons
      context.memo('button.floatLeft', function () {
        return ui.button({
          contents: ui.icon(options.icons.alignLeft),
          tooltip: lang.image.floatLeft,
          click: context.createInvokeHandler('editor.floatMe', 'left')
        }).render();
      });

      context.memo('button.floatRight', function () {
        return ui.button({
          contents: ui.icon(options.icons.alignRight),
          tooltip: lang.image.floatRight,
          click: context.createInvokeHandler('editor.floatMe', 'right')
        }).render();
      });

      context.memo('button.floatNone', function () {
        return ui.button({
          contents: ui.icon(options.icons.alignJustify),
          tooltip: lang.image.floatNone,
          click: context.createInvokeHandler('editor.floatMe', 'none')
        }).render();
      });

      // Remove Buttons
      context.memo('button.removeMedia', function () {
        return ui.button({
          contents: ui.icon(options.icons.trash),
          tooltip: lang.image.remove,
          click: context.createInvokeHandler('editor.removeMedia')
        }).render();
      });
    };

    this.addLinkPopoverButtons = function () {
      context.memo('button.linkDialogShow', function () {
        return ui.button({
          contents: ui.icon(options.icons.link),
          tooltip: lang.link.edit,
          click: context.createInvokeHandler('linkDialog.show')
        }).render();
      });

      context.memo('button.unlink', function () {
        return ui.button({
          contents: ui.icon(options.icons.unlink),
          tooltip: lang.link.unlink,
          click: context.createInvokeHandler('editor.unlink')
        }).render();
      });
    };

    this.build = function ($container, groups) {
      for (var groupIdx = 0, groupLen = groups.length; groupIdx < groupLen; groupIdx++) {
        var group = groups[groupIdx];
        var groupName = group[0];
        var buttons = group[1];

        var $group = ui.buttonGroup({
          className: 'note-' + groupName
        }).render();

        for (var idx = 0, len = buttons.length; idx < len; idx++) {
          var button = context.memo('button.' + buttons[idx]);
          if (button) {
            $group.append(typeof button === 'function' ? button(context) : button);
          }
        }
        $group.appendTo($container);
      }
    };

    this.updateCurrentStyle = function () {
      var styleInfo = context.invoke('editor.currentStyle');
      this.updateBtnStates({
        '.note-btn-bold': function () {
          return styleInfo['font-bold'] === 'bold';
        },
        '.note-btn-italic': function () {
          return styleInfo['font-italic'] === 'italic';
        },
        '.note-btn-underline': function () {
          return styleInfo['font-underline'] === 'underline';
        },
        '.note-btn-subscript': function () {
          return styleInfo['font-subscript'] === 'subscript';
        },
        '.note-btn-superscript': function () {
          return styleInfo['font-superscript'] === 'superscript';
        },
        '.note-btn-strikethrough': function () {
          return styleInfo['font-strikethrough'] === 'strikethrough';
        }
      });

      if (styleInfo['font-family']) {
        var fontNames = styleInfo['font-family'].split(',').map(function (name) {
          return name.replace(/[\'\"]/g, '')
            .replace(/\s+$/, '')
            .replace(/^\s+/, '');
        });
        var fontName = list.find(fontNames, self.isFontInstalled);

        $toolbar.find('.dropdown-fontname li a').each(function () {
          // always compare string to avoid creating another func.
          var isChecked = ($(this).data('value') + '') === (fontName + '');
          this.className = isChecked ? 'checked' : '';
        });
        $toolbar.find('.note-current-fontname').text(fontName);
      }

      if (styleInfo['font-size']) {
        var fontSize = styleInfo['font-size'];
        $toolbar.find('.dropdown-fontsize li a').each(function () {
          // always compare with string to avoid creating another func.
          var isChecked = ($(this).data('value') + '') === (fontSize + '');
          this.className = isChecked ? 'checked' : '';
        });
        $toolbar.find('.note-current-fontsize').text(fontSize);
      }

      if (styleInfo['line-height']) {
        var lineHeight = styleInfo['line-height'];
        $toolbar.find('.dropdown-line-height li a').each(function () {
          // always compare with string to avoid creating another func.
          var isChecked = ($(this).data('value') + '') === (lineHeight + '');
          this.className = isChecked ? 'checked' : '';
        });
      }
    };

    this.updateBtnStates = function (infos) {
      $.each(infos, function (selector, pred) {
        ui.toggleBtnActive($toolbar.find(selector), pred());
      });
    };

    this.tableMoveHandler = function (event) {
      var PX_PER_EM = 18;
      var $picker = $(event.target.parentNode); // target is mousecatcher
      var $dimensionDisplay = $picker.next();
      var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
      var $highlighted = $picker.find('.note-dimension-picker-highlighted');
      var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');

      var posOffset;
      // HTML5 with jQuery - e.offsetX is undefined in Firefox
      if (event.offsetX === undefined) {
        var posCatcher = $(event.target).offset();
        posOffset = {
          x: event.pageX - posCatcher.left,
          y: event.pageY - posCatcher.top
        };
      } else {
        posOffset = {
          x: event.offsetX,
          y: event.offsetY
        };
      }

      var dim = {
        c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
        r: Math.ceil(posOffset.y / PX_PER_EM) || 1
      };

      $highlighted.css({ width: dim.c + 'em', height: dim.r + 'em' });
      $catcher.data('value', dim.c + 'x' + dim.r);

      if (3 < dim.c && dim.c < options.insertTableMaxSize.col) {
        $unhighlighted.css({ width: dim.c + 1 + 'em'});
      }

      if (3 < dim.r && dim.r < options.insertTableMaxSize.row) {
        $unhighlighted.css({ height: dim.r + 1 + 'em'});
      }

      $dimensionDisplay.html(dim.c + ' x ' + dim.r);
    };
  };

  var Toolbar = function (context) {
    var ui = $.summernote.ui;

    var $note = context.layoutInfo.note;
    var $toolbar = context.layoutInfo.toolbar;
    var options = context.options;

    this.shouldInitialize = function () {
      return !options.airMode;
    };

    this.initialize = function () {
      options.toolbar = options.toolbar || [];

      if (!options.toolbar.length) {
        $toolbar.hide();
      } else {
        context.invoke('buttons.build', $toolbar, options.toolbar);
      }

      if (options.toolbarContainer) {
        $toolbar.appendTo(options.toolbarContainer);
      }

      $note.on('summernote.keyup summernote.mouseup summernote.change', function () {
        context.invoke('buttons.updateCurrentStyle');
      });

      context.invoke('buttons.updateCurrentStyle');
    };

    this.destroy = function () {
      $toolbar.children().remove();
    };

    this.updateFullscreen = function (isFullscreen) {
      ui.toggleBtnActive($toolbar.find('.btn-fullscreen'), isFullscreen);
    };

    this.updateCodeview = function (isCodeview) {
      ui.toggleBtnActive($toolbar.find('.btn-codeview'), isCodeview);
      if (isCodeview) {
        this.deactivate();
      } else {
        this.activate();
      }
    };

    this.activate = function (isIncludeCodeview) {
      var $btn = $toolbar.find('button');
      if (!isIncludeCodeview) {
        $btn = $btn.not('.btn-codeview');
      }
      ui.toggleBtn($btn, true);
    };

    this.deactivate = function (isIncludeCodeview) {
      var $btn = $toolbar.find('button');
      if (!isIncludeCodeview) {
        $btn = $btn.not('.btn-codeview');
      }
      ui.toggleBtn($btn, false);
    };
  };

  var LinkDialog = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var $editor = context.layoutInfo.editor;
    var options = context.options;
    var lang = options.langInfo;

    this.initialize = function () {
      var $container = options.dialogsInBody ? $(document.body) : $editor;

      var body = '<div class="form-group">' +
                   '<label>' + lang.link.textToDisplay + '</label>' +
                   '<input class="note-link-text form-control" type="text" />' +
                 '</div>' +
                 '<div class="form-group">' +
                   '<label>' + lang.link.url + '</label>' +
                   '<input class="note-link-url form-control" type="text" value="http://" />' +
                 '</div>' +
                 (!options.disableLinkTarget ?
                   '<div class="checkbox">' +
                     '<label>' + '<input type="checkbox" checked> ' + lang.link.openInNewWindow + '</label>' +
                   '</div>' : ''
                 );
      var footer = '<button href="#" class="btn btn-primary note-link-btn disabled" disabled>' + lang.link.insert + '</button>';

      this.$dialog = ui.dialog({
        className: 'link-dialog',
        title: lang.link.insert,
        fade: options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    };

    this.destroy = function () {
      ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    };

    this.bindEnterKey = function ($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          $btn.trigger('click');
        }
      });
    };

    /**
     * toggle update button
     */
    this.toggleLinkBtn = function ($linkBtn, $linkText, $linkUrl) {
      ui.toggleBtn($linkBtn, $linkText.val() && $linkUrl.val());
    };

    /**
     * Show link dialog and set event handlers on dialog controls.
     *
     * @param {Object} linkInfo
     * @return {Promise}
     */
    this.showLinkDialog = function (linkInfo) {
      return $.Deferred(function (deferred) {
        var $linkText = self.$dialog.find('.note-link-text'),
        $linkUrl = self.$dialog.find('.note-link-url'),
        $linkBtn = self.$dialog.find('.note-link-btn'),
        $openInNewWindow = self.$dialog.find('input[type=checkbox]');

        ui.onDialogShown(self.$dialog, function () {
          context.triggerEvent('dialog.shown');

          // if no url was given, copy text to url
          if (!linkInfo.url) {
            linkInfo.url = linkInfo.text;
          }

          $linkText.val(linkInfo.text);

          var handleLinkTextUpdate = function () {
            self.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
            // if linktext was modified by keyup,
            // stop cloning text from linkUrl
            linkInfo.text = $linkText.val();
          };

          $linkText.on('input', handleLinkTextUpdate).on('paste', function () {
            setTimeout(handleLinkTextUpdate, 0);
          });

          var handleLinkUrlUpdate = function () {
            self.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
            // display same link on `Text to display` input
            // when create a new link
            if (!linkInfo.text) {
              $linkText.val($linkUrl.val());
            }
          };

          $linkUrl.on('input', handleLinkUrlUpdate).on('paste', function () {
            setTimeout(handleLinkUrlUpdate, 0);
          }).val(linkInfo.url).trigger('focus');

          self.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
          self.bindEnterKey($linkUrl, $linkBtn);
          self.bindEnterKey($linkText, $linkBtn);

          $openInNewWindow.prop('checked', linkInfo.isNewWindow);

          $linkBtn.one('click', function (event) {
            event.preventDefault();

            deferred.resolve({
              range: linkInfo.range,
              url: $linkUrl.val(),
              text: $linkText.val(),
              isNewWindow: $openInNewWindow.is(':checked')
            });
            self.$dialog.modal('hide');
          });
        });

        ui.onDialogHidden(self.$dialog, function () {
          // detach events
          $linkText.off('input paste keypress');
          $linkUrl.off('input paste keypress');
          $linkBtn.off('click');

          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });

        ui.showDialog(self.$dialog);
      }).promise();
    };

    /**
     * @param {Object} layoutInfo
     */
    this.show = function () {
      var linkInfo = context.invoke('editor.getLinkInfo');

      context.invoke('editor.saveRange');
      this.showLinkDialog(linkInfo).then(function (linkInfo) {
        context.invoke('editor.restoreRange');
        context.invoke('editor.createLink', linkInfo);
      }).fail(function () {
        context.invoke('editor.restoreRange');
      });
    };
    context.memo('help.linkDialog.show', options.langInfo.help['linkDialog.show']);
  };

  var LinkPopover = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var options = context.options;

    this.events = {
      'summernote.keyup summernote.mouseup summernote.change summernote.scroll': function () {
        self.update();
      },
      'summernote.dialog.shown': function () {
        self.hide();
      }
    };

    this.shouldInitialize = function () {
      return !list.isEmpty(options.popover.link);
    };

    this.initialize = function () {
      this.$popover = ui.popover({
        className: 'note-link-popover',
        callback: function ($node) {
          var $content = $node.find('.popover-content');
          $content.prepend('<span><a target="_blank"></a>&nbsp;</span>');
        }
      }).render().appendTo('body');
      var $content = this.$popover.find('.popover-content');

      context.invoke('buttons.build', $content, options.popover.link);
    };

    this.destroy = function () {
      this.$popover.remove();
    };

    this.update = function () {
      // Prevent focusing on editable when invoke('code') is executed
      if (!context.invoke('editor.hasFocus')) {
        this.hide();
        return;
      }

      var rng = context.invoke('editor.createRange');
      if (rng.isCollapsed() && rng.isOnAnchor()) {
        var anchor = dom.ancestor(rng.sc, dom.isAnchor);
        var href = $(anchor).attr('href');
        this.$popover.find('a').attr('href', href).html(href);

        var pos = dom.posFromPlaceholder(anchor);
        this.$popover.css({
          display: 'block',
          left: pos.left,
          top: pos.top
        });
      } else {
        this.hide();
      }
    };

    this.hide = function () {
      this.$popover.hide();
    };
  };

  var ImageDialog = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var $editor = context.layoutInfo.editor;
    var options = context.options;
    var lang = options.langInfo;

    this.initialize = function () {
      var $container = options.dialogsInBody ? $(document.body) : $editor;

      var imageLimitation = '';
      if (options.maximumImageFileSize) {
        var unit = Math.floor(Math.log(options.maximumImageFileSize) / Math.log(1024));
        var readableSize = (options.maximumImageFileSize / Math.pow(1024, unit)).toFixed(2) * 1 +
                           ' ' + ' KMGTP'[unit] + 'B';
        imageLimitation = '<small>' + lang.image.maximumFileSize + ' : ' + readableSize + '</small>';
      }

      var body = '<div class="form-group note-group-select-from-files">' +
                   '<label>' + lang.image.selectFromFiles + '</label>' +
                   '<input class="note-image-input form-control" type="file" name="files" accept="image/*" multiple="multiple" />' +
                   imageLimitation +
                 '</div>' +
                 '<div class="form-group note-group-image-url" style="overflow:auto;">' +
                   '<label>' + lang.image.url + '</label>' +
                   '<input class="note-image-url form-control col-md-12" type="text" />' +
                 '</div>';
      var footer = '<button href="#" class="btn btn-primary note-image-btn disabled" disabled>' + lang.image.insert + '</button>';

      this.$dialog = ui.dialog({
        title: lang.image.insert,
        fade: options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    };

    this.destroy = function () {
      ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    };

    this.bindEnterKey = function ($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          $btn.trigger('click');
        }
      });
    };

    this.show = function () {
      context.invoke('editor.saveRange');
      this.showImageDialog().then(function (data) {
        // [workaround] hide dialog before restore range for IE range focus
        ui.hideDialog(self.$dialog);
        context.invoke('editor.restoreRange');

        if (typeof data === 'string') { // image url
          context.invoke('editor.insertImage', data);
        } else { // array of files
          context.invoke('editor.insertImagesOrCallback', data);
        }
      }).fail(function () {
        context.invoke('editor.restoreRange');
      });
    };

    /**
     * show image dialog
     *
     * @param {jQuery} $dialog
     * @return {Promise}
     */
    this.showImageDialog = function () {
      return $.Deferred(function (deferred) {
        var $imageInput = self.$dialog.find('.note-image-input'),
            $imageUrl = self.$dialog.find('.note-image-url'),
            $imageBtn = self.$dialog.find('.note-image-btn');

        ui.onDialogShown(self.$dialog, function () {
          context.triggerEvent('dialog.shown');

          // Cloning imageInput to clear element.
          $imageInput.replaceWith($imageInput.clone()
            .on('change', function () {
              deferred.resolve(this.files || this.value);
            })
            .val('')
          );

          $imageBtn.click(function (event) {
            event.preventDefault();

            deferred.resolve($imageUrl.val());
          });

          $imageUrl.on('keyup paste', function () {
            var url = $imageUrl.val();
            ui.toggleBtn($imageBtn, url);
          }).val('').trigger('focus');
          self.bindEnterKey($imageUrl, $imageBtn);
        });

        ui.onDialogHidden(self.$dialog, function () {
          $imageInput.off('change');
          $imageUrl.off('keyup paste keypress');
          $imageBtn.off('click');

          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });

        ui.showDialog(self.$dialog);
      });
    };
  };

  var ImagePopover = function (context) {
    var ui = $.summernote.ui;

    var options = context.options;

    this.shouldInitialize = function () {
      return !list.isEmpty(options.popover.image);
    };

    this.initialize = function () {
      this.$popover = ui.popover({
        className: 'note-image-popover'
      }).render().appendTo('body');
      var $content = this.$popover.find('.popover-content');

      context.invoke('buttons.build', $content, options.popover.image);
    };

    this.destroy = function () {
      this.$popover.remove();
    };

    this.update = function (target) {
      if (dom.isImg(target)) {
        var pos = dom.posFromPlaceholder(target);
        this.$popover.css({
          display: 'block',
          left: pos.left,
          top: pos.top
        });
      } else {
        this.hide();
      }
    };

    this.hide = function () {
      this.$popover.hide();
    };
  };

  var VideoDialog = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var $editor = context.layoutInfo.editor;
    var options = context.options;
    var lang = options.langInfo;

    this.initialize = function () {
      var $container = options.dialogsInBody ? $(document.body) : $editor;

      var body = '<div class="form-group row-fluid">' +
          '<label>' + lang.video.url + ' <small class="text-muted">' + lang.video.providers + '</small></label>' +
          '<input class="note-video-url form-control span12" type="text" />' +
          '</div>';
      var footer = '<button href="#" class="btn btn-primary note-video-btn disabled" disabled>' + lang.video.insert + '</button>';

      this.$dialog = ui.dialog({
        title: lang.video.insert,
        fade: options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    };

    this.destroy = function () {
      ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    };

    this.bindEnterKey = function ($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          $btn.trigger('click');
        }
      });
    };

    this.createVideoNode = function (url) {
      // video url patterns(youtube, instagram, vimeo, dailymotion, youku, mp4, ogg, webm)
      var ytRegExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var ytMatch = url.match(ytRegExp);

      var igRegExp = /(?:www\.|\/\/)instagram\.com\/p\/(.[a-zA-Z0-9_-]*)/;
      var igMatch = url.match(igRegExp);

      var vRegExp = /\/\/vine\.co\/v\/([a-zA-Z0-9]+)/;
      var vMatch = url.match(vRegExp);

      var vimRegExp = /\/\/(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
      var vimMatch = url.match(vimRegExp);

      var dmRegExp = /.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
      var dmMatch = url.match(dmRegExp);

      var youkuRegExp = /\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/;
      var youkuMatch = url.match(youkuRegExp);

      var mp4RegExp = /^.+.(mp4|m4v)$/;
      var mp4Match = url.match(mp4RegExp);

      var oggRegExp = /^.+.(ogg|ogv)$/;
      var oggMatch = url.match(oggRegExp);

      var webmRegExp = /^.+.(webm)$/;
      var webmMatch = url.match(webmRegExp);

      var $video;
      if (ytMatch && ytMatch[1].length === 11) {
        var youtubeId = ytMatch[1];
        $video = $('<iframe>')
            .attr('frameborder', 0)
            .attr('src', '//www.youtube.com/embed/' + youtubeId)
            .attr('width', '640').attr('height', '360');
      } else if (igMatch && igMatch[0].length) {
        $video = $('<iframe>')
            .attr('frameborder', 0)
            .attr('src', 'https://instagram.com/p/' + igMatch[1] + '/embed/')
            .attr('width', '612').attr('height', '710')
            .attr('scrolling', 'no')
            .attr('allowtransparency', 'true');
      } else if (vMatch && vMatch[0].length) {
        $video = $('<iframe>')
            .attr('frameborder', 0)
            .attr('src', vMatch[0] + '/embed/simple')
            .attr('width', '600').attr('height', '600')
            .attr('class', 'vine-embed');
      } else if (vimMatch && vimMatch[3].length) {
        $video = $('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>')
            .attr('frameborder', 0)
            .attr('src', '//player.vimeo.com/video/' + vimMatch[3])
            .attr('width', '640').attr('height', '360');
      } else if (dmMatch && dmMatch[2].length) {
        $video = $('<iframe>')
            .attr('frameborder', 0)
            .attr('src', '//www.dailymotion.com/embed/video/' + dmMatch[2])
            .attr('width', '640').attr('height', '360');
      } else if (youkuMatch && youkuMatch[1].length) {
        $video = $('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>')
            .attr('frameborder', 0)
            .attr('height', '498')
            .attr('width', '510')
            .attr('src', '//player.youku.com/embed/' + youkuMatch[1]);
      } else if (mp4Match || oggMatch || webmMatch) {
        $video = $('<video controls>')
            .attr('src', url)
            .attr('width', '640').attr('height', '360');
      } else {
        // this is not a known video link. Now what, Cat? Now what?
        return false;
      }

      $video.addClass('note-video-clip');

      return $video[0];
    };

    this.show = function () {
      var text = context.invoke('editor.getSelectedText');
      context.invoke('editor.saveRange');
      this.showVideoDialog(text).then(function (url) {
        // [workaround] hide dialog before restore range for IE range focus
        ui.hideDialog(self.$dialog);
        context.invoke('editor.restoreRange');

        // build node
        var $node = self.createVideoNode(url);

        if ($node) {
          // insert video node
          context.invoke('editor.insertNode', $node);
        }
      }).fail(function () {
        context.invoke('editor.restoreRange');
      });
    };

    /**
     * show image dialog
     *
     * @param {jQuery} $dialog
     * @return {Promise}
     */
    this.showVideoDialog = function (text) {
      return $.Deferred(function (deferred) {
        var $videoUrl = self.$dialog.find('.note-video-url'),
            $videoBtn = self.$dialog.find('.note-video-btn');

        ui.onDialogShown(self.$dialog, function () {
          context.triggerEvent('dialog.shown');

          $videoUrl.val(text).on('input', function () {
            ui.toggleBtn($videoBtn, $videoUrl.val());
          }).trigger('focus');

          $videoBtn.click(function (event) {
            event.preventDefault();

            deferred.resolve($videoUrl.val());
          });

          self.bindEnterKey($videoUrl, $videoBtn);
        });

        ui.onDialogHidden(self.$dialog, function () {
          $videoUrl.off('input');
          $videoBtn.off('click');

          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });

        ui.showDialog(self.$dialog);
      });
    };
  };

  var HelpDialog = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var $editor = context.layoutInfo.editor;
    var options = context.options;
    var lang = options.langInfo;

    this.createShortCutList = function () {
      var keyMap = options.keyMap[agent.isMac ? 'mac' : 'pc'];
      return Object.keys(keyMap).map(function (key) {
        var command = keyMap[key];
        var $row = $('<div><div class="help-list-item"/></div>');
        $row.append($('<label><kbd>' + key + '</kdb></label>').css({
          'width': 180,
          'margin-right': 10
        })).append($('<span/>').html(context.memo('help.' + command) || command));
        return $row.html();
      }).join('');
    };

    this.initialize = function () {
      var $container = options.dialogsInBody ? $(document.body) : $editor;

      var body = [
        '<p class="text-center">',
        '<a href="http://summernote.org/" target="_blank">Summernote 0.8.2</a> · ',
        '<a href="https://github.com/summernote/summernote" target="_blank">Project</a> · ',
        '<a href="https://github.com/summernote/summernote/issues" target="_blank">Issues</a>',
        '</p>'
      ].join('');

      this.$dialog = ui.dialog({
        title: lang.options.help,
        fade: options.dialogsFade,
        body: this.createShortCutList(),
        footer: body,
        callback: function ($node) {
          $node.find('.modal-body').css({
            'max-height': 300,
            'overflow': 'scroll'
          });
        }
      }).render().appendTo($container);
    };

    this.destroy = function () {
      ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    };

    /**
     * show help dialog
     *
     * @return {Promise}
     */
    this.showHelpDialog = function () {
      return $.Deferred(function (deferred) {
        ui.onDialogShown(self.$dialog, function () {
          context.triggerEvent('dialog.shown');
          deferred.resolve();
        });
        ui.showDialog(self.$dialog);
      }).promise();
    };

    this.show = function () {
      context.invoke('editor.saveRange');
      this.showHelpDialog().then(function () {
        context.invoke('editor.restoreRange');
      });
    };
  };

  var AirPopover = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var options = context.options;

    var AIR_MODE_POPOVER_X_OFFSET = 20;

    this.events = {
      'summernote.keyup summernote.mouseup summernote.scroll': function () {
        self.update();
      },
      'summernote.change summernote.dialog.shown': function () {
        self.hide();
      },
      'summernote.focusout': function (we, e) {
        // [workaround] Firefox doesn't support relatedTarget on focusout
        //  - Ignore hide action on focus out in FF.
        if (agent.isFF) {
          return;
        }

        if (!e.relatedTarget || !dom.ancestor(e.relatedTarget, func.eq(self.$popover[0]))) {
          self.hide();
        }
      }
    };

    this.shouldInitialize = function () {
      return options.airMode && !list.isEmpty(options.popover.air);
    };

    this.initialize = function () {
      this.$popover = ui.popover({
        className: 'note-air-popover'
      }).render().appendTo('body');
      var $content = this.$popover.find('.popover-content');

      context.invoke('buttons.build', $content, options.popover.air);
    };

    this.destroy = function () {
      this.$popover.remove();
    };

    this.update = function () {
      var styleInfo = context.invoke('editor.currentStyle');
      if (styleInfo.range && !styleInfo.range.isCollapsed()) {
        var rect = list.last(styleInfo.range.getClientRects());
        if (rect) {
          var bnd = func.rect2bnd(rect);
          this.$popover.css({
            display: 'block',
            left: Math.max(bnd.left + bnd.width / 2, 0) - AIR_MODE_POPOVER_X_OFFSET,
            top: bnd.top + bnd.height
          });
        }
      } else {
        this.hide();
      }
    };

    this.hide = function () {
      this.$popover.hide();
    };
  };

  var HintPopover = function (context) {
    var self = this;
    var ui = $.summernote.ui;

    var POPOVER_DIST = 5;
    var hint = context.options.hint || [];
    var direction = context.options.hintDirection || 'bottom';
    var hints = $.isArray(hint) ? hint : [hint];

    this.events = {
      'summernote.keyup': function (we, e) {
        if (!e.isDefaultPrevented()) {
          self.handleKeyup(e);
        }
      },
      'summernote.keydown': function (we, e) {
        self.handleKeydown(e);
      },
      'summernote.dialog.shown': function () {
        self.hide();
      }
    };

    this.shouldInitialize = function () {
      return hints.length > 0;
    };

    this.initialize = function () {
      this.lastWordRange = null;
      this.$popover = ui.popover({
        className: 'note-hint-popover',
        hideArrow: true,
        direction: ''
      }).render().appendTo('body');

      this.$popover.hide();

      this.$content = this.$popover.find('.popover-content');

      this.$content.on('click', '.note-hint-item', function () {
        self.$content.find('.active').removeClass('active');
        $(this).addClass('active');
        self.replace();
      });
    };

    this.destroy = function () {
      this.$popover.remove();
    };

    this.selectItem = function ($item) {
      this.$content.find('.active').removeClass('active');
      $item.addClass('active');

      this.$content[0].scrollTop = $item[0].offsetTop - (this.$content.innerHeight() / 2);
    };

    this.moveDown = function () {
      var $current = this.$content.find('.note-hint-item.active');
      var $next = $current.next();

      if ($next.length) {
        this.selectItem($next);
      } else {
        var $nextGroup = $current.parent().next();

        if (!$nextGroup.length) {
          $nextGroup = this.$content.find('.note-hint-group').first();
        }

        this.selectItem($nextGroup.find('.note-hint-item').first());
      }
    };

    this.moveUp = function () {
      var $current = this.$content.find('.note-hint-item.active');
      var $prev = $current.prev();

      if ($prev.length) {
        this.selectItem($prev);
      } else {
        var $prevGroup = $current.parent().prev();

        if (!$prevGroup.length) {
          $prevGroup = this.$content.find('.note-hint-group').last();
        }

        this.selectItem($prevGroup.find('.note-hint-item').last());
      }
    };

    this.replace = function () {
      var $item = this.$content.find('.note-hint-item.active');

      if ($item.length) {
        var node = this.nodeFromItem($item);
        this.lastWordRange.insertNode(node);
        range.createFromNode(node).collapse().select();

        this.lastWordRange = null;
        this.hide();
        context.invoke('editor.focus');
      }

    };

    this.nodeFromItem = function ($item) {
      var hint = hints[$item.data('index')];
      var item = $item.data('item');
      var node = hint.content ? hint.content(item) : item;
      if (typeof node === 'string') {
        node = dom.createText(node);
      }
      return node;
    };

    this.createItemTemplates = function (hintIdx, items) {
      var hint = hints[hintIdx];
      return items.map(function (item, idx) {
        var $item = $('<div class="note-hint-item"/>');
        $item.append(hint.template ? hint.template(item) : item + '');
        $item.data({
          'index': hintIdx,
          'item': item
        });

        if (hintIdx === 0 && idx === 0) {
          $item.addClass('active');
        }
        return $item;
      });
    };

    this.handleKeydown = function (e) {
      if (!this.$popover.is(':visible')) {
        return;
      }

      if (e.keyCode === key.code.ENTER) {
        e.preventDefault();
        this.replace();
      } else if (e.keyCode === key.code.UP) {
        e.preventDefault();
        this.moveUp();
      } else if (e.keyCode === key.code.DOWN) {
        e.preventDefault();
        this.moveDown();
      }
    };

    this.searchKeyword = function (index, keyword, callback) {
      var hint = hints[index];
      if (hint && hint.match.test(keyword) && hint.search) {
        var matches = hint.match.exec(keyword);
        hint.search(matches[1], callback);
      } else {
        callback();
      }
    };

    this.createGroup = function (idx, keyword) {
      var $group = $('<div class="note-hint-group note-hint-group-' + idx + '"/>');
      this.searchKeyword(idx, keyword, function (items) {
        items = items || [];
        if (items.length) {
          $group.html(self.createItemTemplates(idx, items));
          self.show();
        }
      });

      return $group;
    };

    this.handleKeyup = function (e) {
      if (list.contains([key.code.ENTER, key.code.UP, key.code.DOWN], e.keyCode)) {
        if (e.keyCode === key.code.ENTER) {
          if (this.$popover.is(':visible')) {
            return;
          }
        }
      } else {
        var wordRange = context.invoke('editor.createRange').getWordRange();
        var keyword = wordRange.toString();
        if (hints.length && keyword) {
          this.$content.empty();

          var bnd = func.rect2bnd(list.last(wordRange.getClientRects()));
          if (bnd) {

            this.$popover.hide();

            this.lastWordRange = wordRange;

            hints.forEach(function (hint, idx) {
              if (hint.match.test(keyword)) {
                self.createGroup(idx, keyword).appendTo(self.$content);
              }
            });

            // set position for popover after group is created
            if (direction === 'top') {
              this.$popover.css({
                left: bnd.left,
                top: bnd.top - this.$popover.outerHeight() - POPOVER_DIST
              });
            } else {
              this.$popover.css({
                left: bnd.left,
                top: bnd.top + bnd.height + POPOVER_DIST
              });
            }

          }
        } else {
          this.hide();
        }
      }
    };

    this.show = function () {
      this.$popover.show();
    };

    this.hide = function () {
      this.$popover.hide();
    };
  };


  $.summernote = $.extend($.summernote, {
    version: '0.8.2',
    ui: ui,
    dom: dom,

    plugins: {},

    options: {
      modules: {
        'editor': Editor,
        'clipboard': Clipboard,
        'dropzone': Dropzone,
        'codeview': Codeview,
        'statusbar': Statusbar,
        'fullscreen': Fullscreen,
        'handle': Handle,
        // FIXME: HintPopover must be front of autolink
        //  - Script error about range when Enter key is pressed on hint popover
        'hintPopover': HintPopover,
        'autoLink': AutoLink,
        'autoSync': AutoSync,
        'placeholder': Placeholder,
        'buttons': Buttons,
        'toolbar': Toolbar,
        'linkDialog': LinkDialog,
        'linkPopover': LinkPopover,
        'imageDialog': ImageDialog,
        'imagePopover': ImagePopover,
        'videoDialog': VideoDialog,
        'helpDialog': HelpDialog,
        'airPopover': AirPopover
      },

      buttons: {},

      lang: 'en-US',

      // toolbar
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video']],
        ['view', ['fullscreen', 'codeview', 'help']]
      ],

      // popover
      popover: {
        image: [
          ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
          ['float', ['floatLeft', 'floatRight', 'floatNone']],
          ['remove', ['removeMedia']]
        ],
        link: [
          ['link', ['linkDialogShow', 'unlink']]
        ],
        air: [
          ['color', ['color']],
          ['font', ['bold', 'underline', 'clear']],
          ['para', ['ul', 'paragraph']],
          ['table', ['table']],
          ['insert', ['link', 'picture']]
        ]
      },

      // air mode: inline editor
      airMode: false,

      width: null,
      height: null,

      focus: false,
      tabSize: 4,
      styleWithSpan: true,
      shortcuts: true,
      textareaAutoSync: true,
      direction: null,

      styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],

      fontNames: [
        'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New',
        'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande',
        'Tahoma', 'Times New Roman', 'Verdana'
      ],

      fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36'],

      // pallete colors(n x n)
      colors: [
        ['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF'],
        ['#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF'],
        ['#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE'],
        ['#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD'],
        ['#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5'],
        ['#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B'],
        ['#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842'],
        ['#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031']
      ],

      lineHeights: ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],

      tableClassName: 'table table-bordered',

      insertTableMaxSize: {
        col: 10,
        row: 10
      },

      dialogsInBody: false,
      dialogsFade: false,

      maximumImageFileSize: null,

      callbacks: {
        onInit: null,
        onFocus: null,
        onBlur: null,
        onEnter: null,
        onKeyup: null,
        onKeydown: null,
        onImageUpload: null,
        onImageUploadError: null
      },

      codemirror: {
        mode: 'text/html',
        htmlMode: true,
        lineNumbers: true
      },

      keyMap: {
        pc: {
          'ENTER': 'insertParagraph',
          'CTRL+Z': 'undo',
          'CTRL+Y': 'redo',
          'TAB': 'tab',
          'SHIFT+TAB': 'untab',
          'CTRL+B': 'bold',
          'CTRL+I': 'italic',
          'CTRL+U': 'underline',
          'CTRL+SHIFT+S': 'strikethrough',
          'CTRL+BACKSLASH': 'removeFormat',
          'CTRL+SHIFT+L': 'justifyLeft',
          'CTRL+SHIFT+E': 'justifyCenter',
          'CTRL+SHIFT+R': 'justifyRight',
          'CTRL+SHIFT+J': 'justifyFull',
          'CTRL+SHIFT+NUM7': 'insertUnorderedList',
          'CTRL+SHIFT+NUM8': 'insertOrderedList',
          'CTRL+LEFTBRACKET': 'outdent',
          'CTRL+RIGHTBRACKET': 'indent',
          'CTRL+NUM0': 'formatPara',
          'CTRL+NUM1': 'formatH1',
          'CTRL+NUM2': 'formatH2',
          'CTRL+NUM3': 'formatH3',
          'CTRL+NUM4': 'formatH4',
          'CTRL+NUM5': 'formatH5',
          'CTRL+NUM6': 'formatH6',
          'CTRL+ENTER': 'insertHorizontalRule',
          'CTRL+K': 'linkDialog.show'
        },

        mac: {
          'ENTER': 'insertParagraph',
          'CMD+Z': 'undo',
          'CMD+SHIFT+Z': 'redo',
          'TAB': 'tab',
          'SHIFT+TAB': 'untab',
          'CMD+B': 'bold',
          'CMD+I': 'italic',
          'CMD+U': 'underline',
          'CMD+SHIFT+S': 'strikethrough',
          'CMD+BACKSLASH': 'removeFormat',
          'CMD+SHIFT+L': 'justifyLeft',
          'CMD+SHIFT+E': 'justifyCenter',
          'CMD+SHIFT+R': 'justifyRight',
          'CMD+SHIFT+J': 'justifyFull',
          'CMD+SHIFT+NUM7': 'insertUnorderedList',
          'CMD+SHIFT+NUM8': 'insertOrderedList',
          'CMD+LEFTBRACKET': 'outdent',
          'CMD+RIGHTBRACKET': 'indent',
          'CMD+NUM0': 'formatPara',
          'CMD+NUM1': 'formatH1',
          'CMD+NUM2': 'formatH2',
          'CMD+NUM3': 'formatH3',
          'CMD+NUM4': 'formatH4',
          'CMD+NUM5': 'formatH5',
          'CMD+NUM6': 'formatH6',
          'CMD+ENTER': 'insertHorizontalRule',
          'CMD+K': 'linkDialog.show'
        }
      },
      icons: {
        'align': 'note-icon-align',
        'alignCenter': 'note-icon-align-center',
        'alignJustify': 'note-icon-align-justify',
        'alignLeft': 'note-icon-align-left',
        'alignRight': 'note-icon-align-right',
        'indent': 'note-icon-align-indent',
        'outdent': 'note-icon-align-outdent',
        'arrowsAlt': 'note-icon-arrows-alt',
        'bold': 'note-icon-bold',
        'caret': 'note-icon-caret',
        'circle': 'note-icon-circle',
        'close': 'note-icon-close',
        'code': 'note-icon-code',
        'eraser': 'note-icon-eraser',
        'font': 'note-icon-font',
        'frame': 'note-icon-frame',
        'italic': 'note-icon-italic',
        'link': 'note-icon-link',
        'unlink': 'note-icon-chain-broken',
        'magic': 'note-icon-magic',
        'menuCheck': 'note-icon-check',
        'minus': 'note-icon-minus',
        'orderedlist': 'note-icon-orderedlist',
        'pencil': 'note-icon-pencil',
        'picture': 'note-icon-picture',
        'question': 'note-icon-question',
        'redo': 'note-icon-redo',
        'square': 'note-icon-square',
        'strikethrough': 'note-icon-strikethrough',
        'subscript': 'note-icon-subscript',
        'superscript': 'note-icon-superscript',
        'table': 'note-icon-table',
        'textHeight': 'note-icon-text-height',
        'trash': 'note-icon-trash',
        'underline': 'note-icon-underline',
        'undo': 'note-icon-undo',
        'unorderedlist': 'note-icon-unorderedlist',
        'video': 'note-icon-video'
      }
    }
  });

}));

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/vendor/summernote.js","/admin/source/js/app/lib/vendor")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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